// import { useState, useRef, useEffect } from "react";
// import { motion, AnimatePresence } from "framer-motion";
// import {
//     Bot, Send, X, Minimize2, Maximize2,
//     MessageCircle, User, Loader2,
//     Zap, CheckCircle, Volume2, VolumeX,
//     Copy, ThumbsUp, ThumbsDown
// } from "lucide-react";
// import { io } from "socket.io-client";

// export default function ChatbotWidget() {
//     const [open, setOpen] = useState(false);
//     const [isMinimized, setIsMinimized] = useState(false);
//     const [loading, setLoading] = useState(false);
//     const [messages, setMessages] = useState([
//         {
//             id: "1",
//             text: "👋 Hi there! I'm your AI assistant. How can I help you today?",
//             sender: "bot",
//             timestamp: new Date(),
//             suggestions: [
//                 "Create a website",
//                 "Pricing plans",
//                 "Technical support",
//                 "Book a demo"
//             ]
//         }
//     ]);
//     const [inputMessage, setInputMessage] = useState("");
//     const [isTyping, setIsTyping] = useState(false);
//     const [isVoiceActive, setIsVoiceActive] = useState(false);
//     const messagesEndRef = useRef(null);
//     const inputRef = useRef(null);

//     const socketRef = useRef(null);

//     useEffect(() => {
//         socketRef.current = io("http://localhost:4000");

//         // user join room
//         const userId = "user_" + Date.now();

//         socketRef.current.emit("join_user", { userId });

//         // listen reply
//         socketRef.current.on("chat_reply", (data) => {
//             setMessages(prev => [
//                 ...prev,
//                 {
//                     id: Date.now().toString(),
//                     text: data.reply,
//                     sender: "bot",
//                     timestamp: new Date()
//                 }
//             ]);

//             setLoading(false);
//             setIsTyping(false);
//         });

//         return () => {
//             socketRef.current.disconnect();
//         };
//     }, []);

//     // Auto-scroll to bottom
//     useEffect(() => {
//         messagesEndRef.current?.scrollIntoView({ behavior: "smooth" });
//     }, [messages]);

//     // Focus input when chat opens
//     useEffect(() => {
//         if (open && !isMinimized) {
//             setTimeout(() => inputRef.current?.focus(), 300);
//         }
//     }, [open, isMinimized]);

//     // const sendMessage = async (messageText) => {
//     //     const textToSend = messageText || inputMessage;
//     //     if (!textToSend.trim()) return;

//     //     // Add user message
//     //     const userMessage = {
//     //         id: Date.now().toString(),
//     //         text: textToSend,
//     //         sender: "user",
//     //         timestamp: new Date(),
//     //         status: "sending"
//     //     };
//     //     setMessages(prev => [...prev, userMessage]);
//     //     setInputMessage("");
//     //     setLoading(true);
//     //     setIsTyping(true);

//     //     try {
//     //         const res = await fetch("http://localhost:4000/message/create", {
//     //             method: "POST",
//     //             headers: {
//     //                 "Content-Type": "application/json",
//     //             },
//     //             body: JSON.stringify({  }),
//     //         });

//     //         const data = await res.json();

//     //         // Update user message status
//     //         setMessages(prev => prev.map(msg =>
//     //             msg.id === userMessage.id ? { ...msg, status: "read" } : msg
//     //         ));

//     //         // Add bot response
//     //         const botMessage = {
//     //             id: (Date.now() + 1).toString(),
//     //             text: data?.data?.reply || "I'll help you with that. Could you please provide more details?",
//     //             sender: "bot",
//     //             timestamp: new Date(),
//     //             suggestions: getSuggestionsForMessage(textToSend)
//     //         };
//     //         setMessages(prev => [...prev, botMessage]);
//     //     } catch (err) {
//     //         console.error(err);
//     //         // Add error message
//     //         const errorMessage = {
//     //             id: (Date.now() + 1).toString(),
//     //             text: "Sorry, I'm having trouble connecting. Please try again later.",
//     //             sender: "bot",
//     //             timestamp: new Date(),
//     //         };
//     //         setMessages(prev => [...prev, errorMessage]);
//     //     } finally {
//     //         setLoading(false);
//     //         setIsTyping(false);
//     //     }
//     // };

//     const sendMessage = async (messageText) => {
//         const textToSend = messageText || inputMessage;
//         if (!textToSend.trim()) return;

//         // 🔥 Device info (frontend safe data only)
//         const deviceInfo = {
//             device_name: navigator.userAgent,
//             device_type: /Mobi|Android/i.test(navigator.userAgent) ? "mobile" : "desktop",
//             os: navigator.platform,
//             browser: navigator.userAgent
//         };

//         // 🔥 User message UI
//         const userMessage = {
//             id: Date.now().toString(),
//             text: textToSend,
//             sender: "user",
//             timestamp: new Date(),
//             status: "sending"
//         };

//         setMessages(prev => [...prev, userMessage]);
//         setInputMessage("");
//         setLoading(true);
//         setIsTyping(true);

//         try {
//             const res = await fetch("http://localhost:4000/message/create", {
//                 method: "POST",
//                 headers: {
//                     "Content-Type": "application/json",
//                 },
//                 body: JSON.stringify({
//                     message: textToSend,
//                     companyId: 1,

//                     // 🔥 device info
//                     ...deviceInfo
//                 }),
//             });

//             const data = await res.json();

//             console.log("API Response:", data);

//             // 🔥 Update message status
//             // setMessages(prev =>
//             //     prev.map(msg =>
//             //         msg.id === userMessage.id
//             //             ? { ...msg, status: "read" }
//             //             : msg
//             //     )
//             // );

//             // 🔥 Bot response
//             // const botMessage = {
//             //     id: (Date.now() + 1).toString(),
//             //     text:
//             //         data?.data?.reply ||
//             //         "I'll help you with that. Could you please provide more details?",
//             //     sender: "bot",
//             //     timestamp: new Date(),
//             //     suggestions: getSuggestionsForMessage(textToSend)
//             // };

//             // setMessages(prev => [...prev, botMessage]);

//         } catch (err) {
//             console.error(err);

//             const errorMessage = {
//                 id: (Date.now() + 1).toString(),
//                 text: "Sorry, I'm having trouble connecting. Please try again later.",
//                 sender: "bot",
//                 timestamp: new Date(),
//             };

//             setMessages(prev => [...prev, errorMessage]);
//         } finally {
//             setLoading(false);
//             setIsTyping(false);
//         }
//     };

//     const getSuggestionsForMessage = (message) => {
//         const lowerMsg = message.toLowerCase();
//         if (lowerMsg.includes("website") || lowerMsg.includes("create")) {
//             return ["What's your budget?", "Timeline?", "See portfolio", "Get quote"];
//         }
//         if (lowerMsg.includes("price") || lowerMsg.includes("cost")) {
//             return ["Basic: $499", "Pro: $999", "Enterprise: Custom", "Request demo"];
//         }
//         if (lowerMsg.includes("support") || lowerMsg.includes("help")) {
//             return ["FAQ", "Contact support", "Live chat", "Email us"];
//         }
//         return ["Tell me more", "Show examples", "Get started", "Learn more"];
//     };

//     const handleKeyPress = (e) => {
//         if (e.key === "Enter" && !e.shiftKey) {
//             e.preventDefault();
//             sendMessage();
//         }
//     };

//     const formatTime = (date) => {
//         return date.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
//     };

//     const handleVoiceInput = () => {
//         setIsVoiceActive(!isVoiceActive);
//         // Implement voice recognition here
//         if (!isVoiceActive) {
//             setTimeout(() => {
//                 setInputMessage("I need help with creating a website");
//                 setIsVoiceActive(false);
//             }, 3000);
//         }
//     };

//     const copyMessage = (text) => {
//         navigator.clipboard.writeText(text);
//         // Show toast notification here if needed
//     };

//     const ChatHeader = () => (
//         <div className="bg-gradient-to-r from-blue-600 to-blue-500 p-4 text-white rounded-t-2xl">
//             <div className="flex items-center justify-between">
//                 <div className="flex items-center gap-3">
//                     <div className="relative">
//                         <div className="w-10 h-10 bg-white/20 rounded-xl flex items-center justify-center backdrop-blur-sm">
//                             <Bot className="w-6 h-6" />
//                         </div>
//                         <div className="absolute -bottom-1 -right-1 w-3 h-3 bg-green-500 rounded-full animate-pulse" />
//                     </div>
//                     <div>
//                         <h3 className="font-bold">AI Assistant</h3>
//                         <div className="flex items-center gap-1 text-xs text-blue-100">
//                             <Zap className="w-3 h-3" />
//                             <span>Online • Ready to help</span>
//                         </div>
//                     </div>
//                 </div>
//                 <div className="flex items-center gap-2">
//                     <motion.button
//                         whileHover={{ scale: 1.05 }}
//                         whileTap={{ scale: 0.95 }}
//                         onClick={() => setIsMinimized(!isMinimized)}
//                         className="p-1.5 hover:bg-white/20 rounded-lg transition-colors"
//                     >
//                         {isMinimized ? <Maximize2 className="w-4 h-4" /> : <Minimize2 className="w-4 h-4" />}
//                     </motion.button>
//                     <motion.button
//                         whileHover={{ scale: 1.05 }}
//                         whileTap={{ scale: 0.95 }}
//                         onClick={() => setOpen(false)}
//                         className="p-1.5 hover:bg-white/20 rounded-lg transition-colors"
//                     >
//                         <X className="w-4 h-4" />
//                     </motion.button>
//                 </div>
//             </div>
//         </div>
//     );

//     const ChatMessage = ({ message }) => {
//         const isBot = message.sender === "bot";

//         return (
//             <motion.div
//                 initial={{ opacity: 0, y: 20 }}
//                 animate={{ opacity: 1, y: 0 }}
//                 className={`flex ${isBot ? "justify-start" : "justify-end"} mb-3`}
//             >
//                 <div className={`flex gap-2 max-w-[80%] ${isBot ? "flex-row" : "flex-row-reverse"}`}>
//                     {isBot && (
//                         <div className="w-8 h-8 rounded-full bg-gradient-to-br from-blue-600 to-blue-500 flex items-center justify-center flex-shrink-0 shadow-md">
//                             <Bot className="w-4 h-4 text-white" />
//                         </div>
//                     )}

//                     <div className={`relative group ${!isBot && "order-1"}`}>
//                         <div
//                             className={`p-3 rounded-2xl ${isBot
//                                 ? "bg-gray-100 text-gray-800 rounded-tl-sm"
//                                 : "bg-gradient-to-r from-blue-600 to-blue-500 text-white rounded-tr-sm"
//                                 }`}
//                         >
//                             <p className="text-sm leading-relaxed">{message.text}</p>

//                             {/* Message Actions */}
//                             <div className={`flex items-center gap-1 mt-2 ${isBot ? "justify-start" : "justify-end"} opacity-0 group-hover:opacity-100 transition-opacity`}>
//                                 {isBot ? (
//                                     <>
//                                         <button onClick={() => copyMessage(message.text)} className="p-1 hover:bg-gray-200 rounded-lg transition-colors">
//                                             <Copy className="w-3 h-3 text-gray-500" />
//                                         </button>
//                                         <button className="p-1 hover:bg-gray-200 rounded-lg transition-colors">
//                                             <ThumbsUp className="w-3 h-3 text-gray-500" />
//                                         </button>
//                                         <button className="p-1 hover:bg-gray-200 rounded-lg transition-colors">
//                                             <ThumbsDown className="w-3 h-3 text-gray-500" />
//                                         </button>
//                                     </>
//                                 ) : (
//                                     <div className="flex items-center gap-1">
//                                         {message.status === "sending" && <Loader2 className="w-3 h-3 animate-spin text-white/70" />}
//                                         {message.status === "sent" && <CheckCircle className="w-3 h-3 text-white/70" />}
//                                         {message.status === "read" && <CheckCircle className="w-3 h-3 text-green-300" />}
//                                     </div>
//                                 )}
//                             </div>
//                         </div>

//                         {/* Timestamp */}
//                         <div className={`text-xs text-gray-400 mt-1 ${isBot ? "ml-1" : "mr-1 text-right"}`}>
//                             {formatTime(message.timestamp)}
//                         </div>
//                     </div>

//                     {!isBot && (
//                         <div className="w-8 h-8 rounded-full bg-gradient-to-br from-green-600 to-green-500 flex items-center justify-center flex-shrink-0 shadow-md">
//                             <User className="w-4 h-4 text-white" />
//                         </div>
//                     )}
//                 </div>
//             </motion.div>
//         );
//     };

//     const SuggestionChip = ({ text, onClick }) => (
//         <motion.button
//             whileHover={{ scale: 1.05 }}
//             whileTap={{ scale: 0.95 }}
//             onClick={onClick}
//             className="px-3 py-1.5 bg-blue-50 text-blue-700 text-xs rounded-full hover:bg-blue-100 transition-colors whitespace-nowrap"
//         >
//             {text}
//         </motion.button>
//     );

//     const ChatContent = () => (
//         <div className="flex-1 flex flex-col h-full">
//             {/* Messages Area */}
//             <div className="flex-1 overflow-y-auto p-4 space-y-3">
//                 {messages.map((message) => (
//                     <ChatMessage key={message.id} message={message} />
//                 ))}

//                 {isTyping && (
//                     <motion.div
//                         initial={{ opacity: 0 }}
//                         animate={{ opacity: 1 }}
//                         className="flex justify-start"
//                     >
//                         <div className="flex gap-2">
//                             <div className="w-8 h-8 rounded-full bg-gradient-to-br from-blue-600 to-blue-500 flex items-center justify-center shadow-md">
//                                 <Bot className="w-4 h-4 text-white" />
//                             </div>
//                             <div className="bg-gray-100 p-3 rounded-2xl rounded-tl-sm">
//                                 <div className="flex gap-1">
//                                     <div className="w-2 h-2 bg-gray-400 rounded-full animate-bounce" style={{ animationDelay: "0ms" }} />
//                                     <div className="w-2 h-2 bg-gray-400 rounded-full animate-bounce" style={{ animationDelay: "150ms" }} />
//                                     <div className="w-2 h-2 bg-gray-400 rounded-full animate-bounce" style={{ animationDelay: "300ms" }} />
//                                 </div>
//                             </div>
//                         </div>
//                     </motion.div>
//                 )}

//                 <div ref={messagesEndRef} />
//             </div>

//             {/* Suggestions */}
//             {messages[messages.length - 1]?.sender === "bot" && messages[messages.length - 1]?.suggestions && (
//                 <div className="px-4 py-2 border-t border-gray-100">
//                     <div className="flex gap-2 overflow-x-auto pb-2 scrollbar-hide">
//                         {messages[messages.length - 1].suggestions.map((suggestion, idx) => (
//                             <SuggestionChip key={idx} text={suggestion} onClick={() => sendMessage(suggestion)} />
//                         ))}
//                     </div>
//                 </div>
//             )}

//             {/* Input Area */}
//             <div className="p-4 border-t border-gray-100 bg-gray-50 rounded-b-2xl">
//                 <div className="flex items-center gap-2">
//                     <motion.button
//                         whileTap={{ scale: 0.95 }}
//                         onClick={handleVoiceInput}
//                         className={`p-2.5 rounded-xl transition-all ${isVoiceActive
//                             ? "bg-red-500 text-white animate-pulse"
//                             : "bg-gray-200 text-gray-600 hover:bg-gray-300"
//                             }`}
//                     >
//                         {isVoiceActive ? <VolumeX className="w-5 h-5" /> : <Volume2 className="w-5 h-5" />}
//                     </motion.button>

//                     <input
//                         ref={inputRef}
//                         type="text"
//                         value={inputMessage}
//                         onChange={(e) => setInputMessage(e.target.value)}
//                         onKeyDown={handleKeyPress}
//                         placeholder="Type your message..."
//                         className="flex-1 px-4 py-2.5 bg-white border border-gray-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent text-sm"
//                         disabled={loading}
//                         autoComplete="off"
//                         spellCheck={false}
//                     />

//                     <motion.button
//                         whileHover={{ scale: 1.05 }}
//                         whileTap={{ scale: 0.95 }}
//                         onClick={() => sendMessage()}
//                         disabled={!inputMessage.trim() || loading}
//                         className="p-2.5 bg-gradient-to-r from-blue-600 to-blue-500 text-white rounded-xl hover:shadow-lg transition-all disabled:opacity-50 disabled:cursor-not-allowed"
//                     >
//                         {loading ? <Loader2 className="w-5 h-5 animate-spin" /> : <Send className="w-5 h-5" />}
//                     </motion.button>
//                 </div>

//                 <p className="text-xs text-gray-400 text-center mt-3">
//                     Powered by AI • Responses are generated in real-time
//                 </p>
//             </div>
//         </div>
//     );

//     const MinimizedChat = () => (
//         <motion.div
//             initial={{ opacity: 0, scale: 0.8 }}
//             animate={{ opacity: 1, scale: 1 }}
//             exit={{ opacity: 0, scale: 0.8 }}
//             className="fixed bottom-24 right-5 w-72 bg-white rounded-2xl shadow-2xl border border-blue-100 overflow-hidden"
//         >
//             <div className="bg-gradient-to-r from-blue-600 to-blue-500 p-3 text-white">
//                 <div className="flex items-center justify-between">
//                     <div className="flex items-center gap-2">
//                         <Bot className="w-5 h-5" />
//                         <div>
//                             <p className="font-semibold text-sm">AI Assistant</p>
//                             <p className="text-xs text-blue-100">{messages.length} messages</p>
//                         </div>
//                     </div>
//                     <div className="flex items-center gap-2">
//                         <motion.button
//                             whileHover={{ scale: 1.05 }}
//                             whileTap={{ scale: 0.95 }}
//                             onClick={() => setIsMinimized(false)}
//                             className="p-1 hover:bg-white/20 rounded-lg"
//                         >
//                             <Maximize2 className="w-4 h-4" />
//                         </motion.button>
//                         <motion.button
//                             whileHover={{ scale: 1.05 }}
//                             whileTap={{ scale: 0.95 }}
//                             onClick={() => setOpen(false)}
//                             className="p-1 hover:bg-white/20 rounded-lg"
//                         >
//                             <X className="w-4 h-4" />
//                         </motion.button>
//                     </div>
//                 </div>
//             </div>
//             <div className="p-3 bg-gray-50">
//                 <div className="flex items-center gap-2">
//                     <div className="flex-1 bg-white border border-gray-200 rounded-xl px-3 py-2">
//                         <p className="text-xs text-gray-500 truncate">
//                             {messages[messages.length - 1]?.text || "Click to continue chatting..."}
//                         </p>
//                     </div>
//                     <div className="w-2 h-2 bg-green-500 rounded-full animate-pulse" />
//                 </div>
//             </div>
//         </motion.div>
//     );

//     return (
//         <>
//             {/* Floating Button */}
//             <motion.div
//                 initial={{ scale: 0 }}
//                 animate={{ scale: 1 }}
//                 whileHover={{ scale: 1.1 }}
//                 whileTap={{ scale: 0.9 }}
//                 onClick={() => setOpen(true)}
//                 className="fixed bottom-6 right-6 z-50 cursor-pointer group"
//             >
//                 <div className="absolute inset-0 bg-gradient-to-r from-blue-600 to-blue-500 rounded-full blur-lg opacity-60 group-hover:opacity-100 transition-opacity" />
//                 <div className="relative w-14 h-14 bg-gradient-to-r from-blue-600 to-blue-500 rounded-full flex items-center justify-center shadow-xl group-hover:shadow-2xl transition-all">
//                     <MessageCircle className="w-6 h-6 text-white" />
//                     <div className="absolute -top-1 -right-1 w-4 h-4 bg-green-500 rounded-full animate-pulse border-2 border-white" />
//                     {messages.filter(m => m.sender === "bot" && !m.id.includes("error")).length > 0 && (
//                         <span className="absolute -top-2 -right-2 px-1.5 py-0.5 bg-red-500 text-white text-xs rounded-full">
//                             {messages.filter(m => m.sender === "bot" && !m.id.includes("error")).length}
//                         </span>
//                     )}
//                 </div>
//             </motion.div>

//             {/* Chat Window */}
//             <AnimatePresence>
//                 {open && (
//                     <motion.div
//                         initial={{ opacity: 0, y: 50, scale: 0.9 }}
//                         animate={{ opacity: 1, y: 0, scale: 1 }}
//                         exit={{ opacity: 0, y: 50, scale: 0.9 }}
//                         transition={{ type: "spring", damping: 25 }}
//                         className="fixed bottom-24 right-6 z-50"
//                     >
//                         {isMinimized ? (
//                             <MinimizedChat />
//                         ) : (
//                             <div className="w-[400px] h-[600px] bg-white rounded-2xl shadow-2xl overflow-hidden flex flex-col">
//                                 <ChatHeader />
//                                 <ChatContent />
//                             </div>
//                         )}
//                     </motion.div>
//                 )}
//             </AnimatePresence>
//         </>
//     );
// }


// import { useState, useRef, useEffect } from "react";
// import { motion, AnimatePresence } from "framer-motion";
// import {
//     Bot, Send, X, Minimize2, Maximize2,
//     MessageCircle, User, Loader2,
//     Zap, CheckCircle, Volume2, VolumeX,
//     Copy, ThumbsUp, ThumbsDown, Sparkles
// } from "lucide-react";
// import { io } from "socket.io-client";

// export default function ChatbotWidget() {
//     const [open, setOpen] = useState(false);
//     const [isMinimized, setIsMinimized] = useState(false);
//     const [loading, setLoading] = useState(false);
//     const [messages, setMessages] = useState([
//         {
//             id: "1",
//             text: "👋 Hi there! I'm Momin's AI assistant. Ready to help you build something amazing!",
//             sender: "bot",
//             timestamp: new Date(),
//             suggestions: [
//                 "💼 Create a website",
//                 "💰 Pricing plans",
//                 "🛠️ Technical support",
//                 "📅 Book a demo"
//             ]
//         }
//     ]);
//     const [inputMessage, setInputMessage] = useState("");
//     const [isTyping, setIsTyping] = useState(false);
//     const [isVoiceActive, setIsVoiceActive] = useState(false);
//     const messagesEndRef = useRef(null);
//     const inputRef = useRef(null);
//     const [copiedId, setCopiedId] = useState(null);
//     const [feedbackGiven, setFeedbackGiven] = useState({});

//     const socketRef = useRef(null);
//     const userIdRef = useRef("user_" + Date.now());

//     useEffect(() => {
//         socketRef.current = io("http://localhost:4000");

//         // const userId = "user_" + Date.now();



//         // socketRef.current.emit("join_user", { userId });

//         socketRef.current.emit("join_user", {
//             userId: userIdRef.current
//         });

//         socketRef.current.on("chat_reply", (data) => {
//             setMessages(prev => [
//                 ...prev,
//                 {
//                     id: Date.now().toString(),
//                     text: data.reply,
//                     sender: "bot",
//                     timestamp: new Date(),
//                     suggestions: getSuggestionsForMessage(data.reply)
//                 }
//             ]);

//             setLoading(false);
//             setIsTyping(false);
//         });

//         return () => {
//             socketRef.current.disconnect();
//         };
//     }, []);

//     useEffect(() => {
//         messagesEndRef.current?.scrollIntoView({ behavior: "smooth" });
//     }, [messages]);

//     useEffect(() => {
//         if (open && !isMinimized) {
//             setTimeout(() => {
//                 if (inputRef.current) {
//                     inputRef.current.focus();
//                 }
//             }, 300);
//         }
//     }, [open, isMinimized]);

//     const sendMessage = async (messageText) => {
//         const textToSend = messageText || inputMessage;
//         if (!textToSend.trim()) return;

//         const deviceInfo = {
//             device_name: navigator.userAgent,
//             device_type: /Mobi|Android/i.test(navigator.userAgent) ? "mobile" : "desktop",
//             os: navigator.platform,
//             browser: navigator.userAgent
//         };

//         const userMessage = {
//             id: Date.now().toString(),
//             text: textToSend,
//             sender: "user",
//             timestamp: new Date(),
//             status: "sending"
//         };

//         setMessages(prev => [...prev, userMessage]);
//         setInputMessage("");
//         setLoading(true);
//         setIsTyping(true);

//         try {
//             const res = await fetch("http://localhost:4000/message/create", {
//                 method: "POST",
//                 headers: {
//                     "Content-Type": "application/json",
//                 },
//                 body: JSON.stringify({
//                     message: textToSend,
//                     companyId: 1,
//                     ...deviceInfo
//                 }),
//             });

//             const data = await res.json();

//             setMessages(prev =>
//                 prev.map(msg =>
//                     msg.id === userMessage.id
//                         ? { ...msg, status: "read" }
//                         : msg
//                 )
//             );

//         } catch (err) {
//             console.error(err);

//             const errorMessage = {
//                 id: (Date.now() + 1).toString(),
//                 text: "Sorry, I'm having trouble connecting. Please try again later or contact us directly on WhatsApp.",
//                 sender: "bot",
//                 timestamp: new Date(),
//                 suggestions: ["📞 Contact on WhatsApp", "🔄 Try again", "📧 Send email"]
//             };

//             setMessages(prev => [...prev, errorMessage]);
//         } finally {
//             setLoading(false);
//             setIsTyping(false);
//         }
//     };

//     const getSuggestionsForMessage = (message) => {
//         const lowerMsg = message.toLowerCase();
//         if (lowerMsg.includes("website") || lowerMsg.includes("create")) {
//             return ["What's your budget?", "Timeline?", "See portfolio", "Get quote"];
//         }
//         if (lowerMsg.includes("price") || lowerMsg.includes("cost")) {
//             return ["Basic: $499", "Pro: $999", "Enterprise: Custom", "Request demo"];
//         }
//         if (lowerMsg.includes("support") || lowerMsg.includes("help")) {
//             return ["FAQ", "Contact support", "Live chat", "Email us"];
//         }
//         return ["Tell me more", "Show examples", "Get started", "Learn more"];
//     };

//     const handleKeyPress = (e) => {
//         if (e.key === "Enter" && !e.shiftKey) {
//             e.preventDefault();
//             sendMessage();
//         }
//     };

//     const formatTime = (date) => {
//         return date.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
//     };

//     const handleVoiceInput = () => {
//         setIsVoiceActive(!isVoiceActive);
//         if (!isVoiceActive && 'webkitSpeechRecognition' in window) {
//             const recognition = new window.webkitSpeechRecognition();
//             recognition.continuous = false;
//             recognition.interimResults = false;
//             recognition.lang = 'en-US';

//             recognition.onstart = () => {
//                 setIsVoiceActive(true);
//             };

//             recognition.onresult = (event) => {
//                 const transcript = event.results[0][0].transcript;
//                 setInputMessage(transcript);
//                 setIsVoiceActive(false);
//                 setTimeout(() => {
//                     if (inputRef.current) {
//                         inputRef.current.focus();
//                     }
//                 }, 100);
//             };

//             recognition.onerror = () => {
//                 setIsVoiceActive(false);
//             };

//             recognition.onend = () => {
//                 setIsVoiceActive(false);
//             };

//             recognition.start();
//         } else if (!isVoiceActive) {
//             alert("Voice recognition is not supported in your browser. Please try Chrome or Edge.");
//         }
//     };

//     const copyMessage = (text, id) => {
//         navigator.clipboard.writeText(text);
//         setCopiedId(id);
//         setTimeout(() => setCopiedId(null), 2000);
//     };

//     const giveFeedback = (id, type) => {
//         setFeedbackGiven(prev => ({ ...prev, [id]: type }));
//         // Here you can send feedback to your backend
//         console.log(`Feedback for message ${id}: ${type}`);
//     };

//     const handleSuggestionClick = (suggestion) => {
//         sendMessage(suggestion);
//     };

//     const ChatHeader = () => (
//         <div className="bg-gradient-to-r from-blue-600 to-emerald-500 p-4 text-white rounded-t-2xl">
//             <div className="flex items-center justify-between">
//                 <div className="flex items-center gap-3">
//                     <div className="relative">
//                         <div className="w-10 h-10 bg-white/20 rounded-xl flex items-center justify-center backdrop-blur-sm">
//                             <Bot className="w-6 h-6" />
//                         </div>
//                         <div className="absolute -bottom-1 -right-1 w-3 h-3 bg-green-500 rounded-full animate-pulse" />
//                     </div>
//                     <div>
//                         <h3 className="font-bold text-lg">Momin's AI Assistant</h3>
//                         <div className="flex items-center gap-1 text-xs text-blue-100">
//                             <Zap className="w-3 h-3" />
//                             <span>Online • Ready to help you grow</span>
//                         </div>
//                     </div>
//                 </div>
//                 <div className="flex items-center gap-2">
//                     <motion.button
//                         whileHover={{ scale: 1.05 }}
//                         whileTap={{ scale: 0.95 }}
//                         onClick={() => setIsMinimized(!isMinimized)}
//                         className="p-1.5 hover:bg-white/20 rounded-lg transition-colors"
//                     >
//                         {isMinimized ? <Maximize2 className="w-4 h-4" /> : <Minimize2 className="w-4 h-4" />}
//                     </motion.button>
//                     <motion.button
//                         whileHover={{ scale: 1.05 }}
//                         whileTap={{ scale: 0.95 }}
//                         onClick={() => setOpen(false)}
//                         className="p-1.5 hover:bg-white/20 rounded-lg transition-colors"
//                     >
//                         <X className="w-4 h-4" />
//                     </motion.button>
//                 </div>
//             </div>
//         </div>
//     );

//     const ChatMessage = ({ message }) => {
//         const isBot = message.sender === "bot";

//         return (
//             <motion.div
//                 initial={{ opacity: 0, y: 20 }}
//                 animate={{ opacity: 1, y: 0 }}
//                 className={`flex ${isBot ? "justify-start" : "justify-end"} mb-4`}
//             >
//                 <div className={`flex gap-2 max-w-[85%] ${isBot ? "flex-row" : "flex-row-reverse"}`}>
//                     {isBot && (
//                         <div className="w-8 h-8 rounded-full bg-gradient-to-br from-blue-600 to-emerald-500 flex items-center justify-center flex-shrink-0 shadow-md">
//                             <Bot className="w-4 h-4 text-white" />
//                         </div>
//                     )}

//                     <div className={`relative group ${!isBot && "order-1"}`}>
//                         <div
//                             className={`p-3 rounded-2xl ${isBot
//                                 ? "bg-gradient-to-r from-gray-100 to-gray-50 text-gray-800 rounded-tl-sm shadow-sm"
//                                 : "bg-gradient-to-r from-blue-600 to-emerald-500 text-white rounded-tr-sm shadow-md"
//                                 }`}
//                         >
//                             <p className="text-sm leading-relaxed">{message.text}</p>

//                             {/* Message Actions */}
//                             <div className={`flex items-center gap-1 mt-2 ${isBot ? "justify-start" : "justify-end"} opacity-0 group-hover:opacity-100 transition-opacity`}>
//                                 {isBot ? (
//                                     <>
//                                         <button onClick={() => copyMessage(message.text, message.id)} className="p-1 hover:bg-gray-200 rounded-lg transition-colors">
//                                             {copiedId === message.id ? <CheckCircle className="w-3 h-3 text-green-500" /> : <Copy className="w-3 h-3 text-gray-500" />}
//                                         </button>
//                                         <button
//                                             onClick={() => giveFeedback(message.id, 'like')}
//                                             className={`p-1 hover:bg-gray-200 rounded-lg transition-colors ${feedbackGiven[message.id] === 'like' ? 'text-green-500' : 'text-gray-500'}`}
//                                         >
//                                             <ThumbsUp className="w-3 h-3" />
//                                         </button>
//                                         <button
//                                             onClick={() => giveFeedback(message.id, 'dislike')}
//                                             className={`p-1 hover:bg-gray-200 rounded-lg transition-colors ${feedbackGiven[message.id] === 'dislike' ? 'text-red-500' : 'text-gray-500'}`}
//                                         >
//                                             <ThumbsDown className="w-3 h-3" />
//                                         </button>
//                                     </>
//                                 ) : (
//                                     <div className="flex items-center gap-1">
//                                         {message.status === "sending" && <Loader2 className="w-3 h-3 animate-spin text-white/70" />}
//                                         {message.status === "sent" && <CheckCircle className="w-3 h-3 text-white/70" />}
//                                         {message.status === "read" && <CheckCircle className="w-3 h-3 text-green-300" />}
//                                     </div>
//                                 )}
//                             </div>
//                         </div>

//                         {/* Timestamp */}
//                         <div className={`text-xs text-gray-400 mt-1 ${isBot ? "ml-1" : "mr-1 text-right"}`}>
//                             {formatTime(message.timestamp)}
//                         </div>
//                     </div>

//                     {!isBot && (
//                         <div className="w-8 h-8 rounded-full bg-gradient-to-br from-gray-700 to-gray-800 flex items-center justify-center flex-shrink-0 shadow-md">
//                             <User className="w-4 h-4 text-white" />
//                         </div>
//                     )}
//                 </div>
//             </motion.div>
//         );
//     };

//     const SuggestionChip = ({ text, onClick }) => (
//         <motion.button
//             whileHover={{ scale: 1.05, y: -2 }}
//             whileTap={{ scale: 0.95 }}
//             onClick={() => onClick(text)}
//             className="px-3 py-1.5 bg-gradient-to-r from-blue-50 to-emerald-50 text-blue-700 text-xs rounded-full hover:from-blue-100 hover:to-emerald-100 transition-all whitespace-nowrap shadow-sm"
//         >
//             {text}
//         </motion.button>
//     );

//     const ChatContent = () => (
//         <div className="flex-1 flex flex-col h-full bg-white">
//             {/* Messages Area */}
//             <div className="flex-1 overflow-y-auto p-4 space-y-3 bg-gradient-to-b from-gray-50 to-white">
//                 {messages.map((message) => (
//                     <ChatMessage key={message.id} message={message} />
//                 ))}

//                 {isTyping && (
//                     <motion.div
//                         initial={{ opacity: 0 }}
//                         animate={{ opacity: 1 }}
//                         className="flex justify-start"
//                     >
//                         <div className="flex gap-2">
//                             <div className="w-8 h-8 rounded-full bg-gradient-to-br from-blue-600 to-emerald-500 flex items-center justify-center shadow-md">
//                                 <Bot className="w-4 h-4 text-white" />
//                             </div>
//                             <div className="bg-gray-100 p-3 rounded-2xl rounded-tl-sm shadow-sm">
//                                 <div className="flex gap-1">
//                                     <div className="w-2 h-2 bg-blue-400 rounded-full animate-bounce" style={{ animationDelay: "0ms" }} />
//                                     <div className="w-2 h-2 bg-blue-400 rounded-full animate-bounce" style={{ animationDelay: "150ms" }} />
//                                     <div className="w-2 h-2 bg-blue-400 rounded-full animate-bounce" style={{ animationDelay: "300ms" }} />
//                                 </div>
//                             </div>
//                         </div>
//                     </motion.div>
//                 )}

//                 <div ref={messagesEndRef} />
//             </div>

//             {/* Suggestions */}
//             {messages[messages.length - 1]?.sender === "bot" && messages[messages.length - 1]?.suggestions && messages[messages.length - 1]?.suggestions.length > 0 && (
//                 <div className="px-4 py-3 border-t border-gray-100 bg-gray-50">
//                     <div className="flex gap-2 overflow-x-auto pb-2 scrollbar-hide">
//                         {messages[messages.length - 1].suggestions.map((suggestion, idx) => (
//                             <SuggestionChip key={idx} text={suggestion} onClick={handleSuggestionClick} />
//                         ))}
//                     </div>
//                 </div>
//             )}

//             {/* Input Area - FIXED: No more auto-unfocus issue */}
//             <div className="p-4 border-t border-gray-100 bg-white rounded-b-2xl">
//                 <div className="flex items-center gap-2">
//                     <motion.button
//                         whileTap={{ scale: 0.95 }}
//                         onClick={handleVoiceInput}
//                         className={`p-2.5 rounded-xl transition-all ${isVoiceActive
//                             ? "bg-red-500 text-white animate-pulse"
//                             : "bg-gray-100 text-gray-600 hover:bg-gray-200"
//                             }`}
//                     >
//                         {isVoiceActive ? <VolumeX className="w-5 h-5" /> : <Volume2 className="w-5 h-5" />}
//                     </motion.button>

//                     <input
//                         ref={inputRef}
//                         type="text"
//                         value={inputMessage}
//                         onChange={(e) => setInputMessage(e.target.value)}
//                         onKeyDown={handleKeyPress}
//                         placeholder="Type your message..."
//                         className="flex-1 px-4 py-2.5 bg-gray-50 border border-gray-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent text-sm text-gray-800 placeholder-gray-400"
//                         disabled={loading}
//                         autoComplete="off"
//                         spellCheck={false}
//                     />

//                     <motion.button
//                         whileHover={{ scale: 1.05 }}
//                         whileTap={{ scale: 0.95 }}
//                         onClick={() => sendMessage()}
//                         disabled={!inputMessage.trim() || loading}
//                         className="p-2.5 bg-gradient-to-r from-blue-600 to-emerald-500 text-white rounded-xl hover:shadow-lg transition-all disabled:opacity-50 disabled:cursor-not-allowed"
//                     >
//                         {loading ? <Loader2 className="w-5 h-5 animate-spin" /> : <Send className="w-5 h-5" />}
//                     </motion.button>
//                 </div>

//                 <div className="flex items-center justify-between mt-3">
//                     <p className="text-xs text-gray-400">
//                         Powered by AI • Real-time responses
//                     </p>
//                     <button
//                         onClick={() => window.location.href = 'https://wa.me/923112891862'}
//                         className="text-xs text-green-600 hover:text-green-700 font-medium flex items-center gap-1"
//                     >
//                         <MessageCircle className="w-3 h-3" />
//                         Contact on WhatsApp
//                     </button>
//                 </div>
//             </div>
//         </div>
//     );

//     const MinimizedChat = () => (
//         <motion.div
//             initial={{ opacity: 0, scale: 0.8 }}
//             animate={{ opacity: 1, scale: 1 }}
//             exit={{ opacity: 0, scale: 0.8 }}
//             className="fixed bottom-24 right-5 w-80 bg-white rounded-2xl shadow-2xl border border-blue-100 overflow-hidden"
//         >
//             <div className="bg-gradient-to-r from-blue-600 to-emerald-500 p-3 text-white">
//                 <div className="flex items-center justify-between">
//                     <div className="flex items-center gap-2">
//                         <Bot className="w-5 h-5" />
//                         <div>
//                             <p className="font-semibold text-sm">Momin's AI Assistant</p>
//                             <p className="text-xs text-blue-100">{messages.length} messages</p>
//                         </div>
//                     </div>
//                     <div className="flex items-center gap-2">
//                         <motion.button
//                             whileHover={{ scale: 1.05 }}
//                             whileTap={{ scale: 0.95 }}
//                             onClick={() => setIsMinimized(false)}
//                             className="p-1 hover:bg-white/20 rounded-lg"
//                         >
//                             <Maximize2 className="w-4 h-4" />
//                         </motion.button>
//                         <motion.button
//                             whileHover={{ scale: 1.05 }}
//                             whileTap={{ scale: 0.95 }}
//                             onClick={() => setOpen(false)}
//                             className="p-1 hover:bg-white/20 rounded-lg"
//                         >
//                             <X className="w-4 h-4" />
//                         </motion.button>
//                     </div>
//                 </div>
//             </div>
//             <div className="p-3 bg-gray-50">
//                 <div className="flex items-center gap-2">
//                     <div className="flex-1 bg-white border border-gray-200 rounded-xl px-3 py-2">
//                         <p className="text-xs text-gray-500 truncate">
//                             {messages[messages.length - 1]?.text || "Click to continue chatting..."}
//                         </p>
//                     </div>
//                     <div className="w-2 h-2 bg-green-500 rounded-full animate-pulse" />
//                 </div>
//             </div>
//         </motion.div>
//     );

//     return (
//         <>
//             {/* Floating Button */}
//             <motion.div
//                 initial={{ scale: 0 }}
//                 animate={{ scale: 1 }}
//                 whileHover={{ scale: 1.1 }}
//                 whileTap={{ scale: 0.9 }}
//                 onClick={() => setOpen(true)}
//                 className="fixed bottom-6 right-6 z-50 cursor-pointer group"
//             >
//                 <div className="absolute inset-0 bg-gradient-to-r from-blue-600 to-emerald-500 rounded-full blur-lg opacity-60 group-hover:opacity-100 transition-opacity" />
//                 <div className="relative w-14 h-14 bg-gradient-to-r from-blue-600 to-emerald-500 rounded-full flex items-center justify-center shadow-xl group-hover:shadow-2xl transition-all">
//                     <MessageCircle className="w-6 h-6 text-white" />
//                     <div className="absolute -top-1 -right-1 w-4 h-4 bg-green-500 rounded-full animate-pulse border-2 border-white" />
//                     {messages.filter(m => m.sender === "bot" && m.id !== "1").length > 0 && (
//                         <span className="absolute -top-2 -right-2 px-1.5 py-0.5 bg-red-500 text-white text-xs rounded-full">
//                             {messages.filter(m => m.sender === "bot" && m.id !== "1").length}
//                         </span>
//                     )}
//                 </div>
//             </motion.div>

//             {/* Chat Window */}
//             <AnimatePresence>
//                 {open && (
//                     <motion.div
//                         initial={{ opacity: 0, y: 50, scale: 0.9 }}
//                         animate={{ opacity: 1, y: 0, scale: 1 }}
//                         exit={{ opacity: 0, y: 50, scale: 0.9 }}
//                         transition={{ type: "spring", damping: 25 }}
//                         className="fixed bottom-24 right-6 z-50"
//                     >
//                         {isMinimized ? (
//                             <MinimizedChat />
//                         ) : (
//                             <div className="w-[420px] h-[650px] bg-white rounded-2xl shadow-2xl overflow-hidden flex flex-col">
//                                 <ChatHeader />
//                                 <ChatContent />
//                             </div>
//                         )}
//                     </motion.div>
//                 )}
//             </AnimatePresence>
//         </>
//     );
// }


// import { useState, useRef, useEffect, useCallback, useMemo } from "react";
// import { motion, AnimatePresence } from "framer-motion";
// import {
//     Bot, Send, X, Minimize2, Maximize2,
//     MessageCircle, User, Loader2,
//     Zap, CheckCircle, Volume2, VolumeX,
//     Copy, ThumbsUp, ThumbsDown, Sparkles
// } from "lucide-react";
// import { io } from "socket.io-client";

// export default function ChatbotWidget() {
//     const [open, setOpen] = useState(false);
//     const [isMinimized, setIsMinimized] = useState(false);
//     const [loading, setLoading] = useState(false);
//     const [messages, setMessages] = useState(() => [
//         {
//             id: "1",
//             text: "👋 Hi there! I'm Momin's AI assistant. Ready to help you build something amazing!",
//             sender: "bot",
//             timestamp: new Date(),
//             suggestions: [
//                 "💼 Create a website",
//                 "💰 Pricing plans",
//                 "🛠️ Technical support",
//                 "📅 Book a demo"
//             ]
//         }
//     ]);
//     const [inputMessage, setInputMessage] = useState("");
//     const [isTyping, setIsTyping] = useState(false);
//     const [isVoiceActive, setIsVoiceActive] = useState(false);
//     const messagesEndRef = useRef(null);
//     const inputRef = useRef(null);
//     const [copiedId, setCopiedId] = useState(null);
//     const [feedbackGiven, setFeedbackGiven] = useState({});
//     const socketRef = useRef(null);
//     const isLoadingRef = useRef(false);
//     const messagesCountRef = useRef(messages.length);

//     // Memoize getSuggestionsForMessage to prevent recreation
//     const getSuggestionsForMessage = useCallback((message) => {
//         const lowerMsg = message.toLowerCase();
//         if (lowerMsg.includes("website") || lowerMsg.includes("create")) {
//             return ["What's your budget?", "Timeline?", "See portfolio", "Get quote"];
//         }
//         if (lowerMsg.includes("price") || lowerMsg.includes("cost")) {
//             return ["Basic: $499", "Pro: $999", "Enterprise: Custom", "Request demo"];
//         }
//         if (lowerMsg.includes("support") || lowerMsg.includes("help")) {
//             return ["FAQ", "Contact support", "Live chat", "Email us"];
//         }
//         return ["Tell me more", "Show examples", "Get started", "Learn more"];
//     }, []);

//     // Socket connection - stable reference
//     useEffect(() => {
//         if (socketRef.current) return;

//         socketRef.current = io("http://localhost:4000", {
//             reconnection: true,
//             reconnectionAttempts: 5,
//             reconnectionDelay: 1000
//         });

//         const userId = "user_" + Date.now();
//         socketRef.current.emit("join_user", { userId });

//         socketRef.current.on("chat_reply", (data) => {
//             setMessages(prev => {
//                 const newMessages = [...prev, {
//                     id: Date.now().toString(),
//                     text: data.reply,
//                     sender: "bot",
//                     timestamp: new Date(),
//                     suggestions: getSuggestionsForMessage(data.reply)
//                 }];
//                 messagesCountRef.current = newMessages.length;
//                 return newMessages;
//             });
//             setLoading(false);
//             setIsTyping(false);
//             isLoadingRef.current = false;
//         });

//         return () => {
//             if (socketRef.current) {
//                 socketRef.current.disconnect();
//                 socketRef.current = null;
//             }
//         };
//     }, [getSuggestionsForMessage]);

//     // Auto-scroll - optimized
//     useEffect(() => {
//         if (messagesEndRef.current) {
//             messagesEndRef.current.scrollIntoView({ behavior: "smooth", block: "end" });
//         }
//     }, [messages.length]);

//     // Focus input - stable
//     useEffect(() => {
//         if (open && !isMinimized && inputRef.current && document.activeElement !== inputRef.current) {
//             const timer = setTimeout(() => {
//                 inputRef.current?.focus();
//             }, 100);
//             return () => clearTimeout(timer);
//         }
//     }, [open, isMinimized]);

//     const sendMessage = useCallback(async (messageText) => {
//         const textToSend = messageText || inputMessage;
//         if (!textToSend.trim() || isLoadingRef.current) return;

//         isLoadingRef.current = true;

//         const deviceInfo = {
//             device_name: navigator.userAgent,
//             device_type: /Mobi|Android/i.test(navigator.userAgent) ? "mobile" : "desktop",
//             os: navigator.platform,
//             browser: navigator.userAgent
//         };

//         const userMessage = {
//             id: Date.now().toString(),
//             text: textToSend,
//             sender: "user",
//             timestamp: new Date(),
//             status: "sending"
//         };

//         setMessages(prev => {
//             const newMessages = [...prev, userMessage];
//             messagesCountRef.current = newMessages.length;
//             return newMessages;
//         });

//         setInputMessage("");
//         setLoading(true);
//         setIsTyping(true);

//         try {
//             const res = await fetch("http://localhost:4000/message/create", {
//                 method: "POST",
//                 headers: {
//                     "Content-Type": "application/json",
//                 },
//                 body: JSON.stringify({
//                     message: textToSend,
//                     companyId: 1,
//                     ...deviceInfo
//                 }),
//             });

//             const data = await res.json();

//             setMessages(prev =>
//                 prev.map(msg =>
//                     msg.id === userMessage.id
//                         ? { ...msg, status: "read" }
//                         : msg
//                 )
//             );

//         } catch (err) {
//             console.error(err);

//             const errorMessage = {
//                 id: (Date.now() + 1).toString(),
//                 text: "Sorry, I'm having trouble connecting. Please try again later or contact us directly on WhatsApp.",
//                 sender: "bot",
//                 timestamp: new Date(),
//                 suggestions: ["📞 Contact on WhatsApp", "🔄 Try again", "📧 Send email"]
//             };

//             setMessages(prev => {
//                 const newMessages = [...prev, errorMessage];
//                 messagesCountRef.current = newMessages.length;
//                 return newMessages;
//             });
//         } finally {
//             setLoading(false);
//             setIsTyping(false);
//             isLoadingRef.current = false;
//         }
//     }, [inputMessage]);

//     const handleInputChange = useCallback((e) => {
//         setInputMessage(e.target.value);
//     }, []);

//     const handleKeyPress = useCallback((e) => {
//         if (e.key === "Enter" && !e.shiftKey && !loading && inputMessage.trim()) {
//             e.preventDefault();
//             sendMessage();
//         }
//     }, [sendMessage, loading, inputMessage]);

//     const formatTime = useCallback((date) => {
//         return date.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
//     }, []);

//     const handleVoiceInput = useCallback(() => {
//         if (!isVoiceActive && 'webkitSpeechRecognition' in window) {
//             const recognition = new window.webkitSpeechRecognition();
//             recognition.continuous = false;
//             recognition.interimResults = false;
//             recognition.lang = 'en-US';

//             recognition.onstart = () => {
//                 setIsVoiceActive(true);
//             };

//             recognition.onresult = (event) => {
//                 const transcript = event.results[0][0].transcript;
//                 setInputMessage(transcript);
//                 setIsVoiceActive(false);
//                 setTimeout(() => {
//                     inputRef.current?.focus();
//                 }, 100);
//             };

//             recognition.onerror = () => {
//                 setIsVoiceActive(false);
//             };

//             recognition.onend = () => {
//                 setIsVoiceActive(false);
//             };

//             recognition.start();
//         } else if (!isVoiceActive) {
//             alert("Voice recognition is not supported in your browser. Please try Chrome or Edge.");
//         }
//     }, [isVoiceActive]);

//     const copyMessage = useCallback((text, id) => {
//         navigator.clipboard.writeText(text);
//         setCopiedId(id);
//         setTimeout(() => setCopiedId(null), 2000);
//     }, []);

//     const giveFeedback = useCallback((id, type) => {
//         setFeedbackGiven(prev => ({ ...prev, [id]: type }));
//     }, []);

//     const handleSuggestionClick = useCallback((suggestion) => {
//         sendMessage(suggestion);
//     }, [sendMessage]);

//     const toggleChat = useCallback(() => {
//         setOpen(prev => !prev);
//     }, []);

//     const toggleMinimize = useCallback(() => {
//         setIsMinimized(prev => !prev);
//     }, []);

//     const closeChat = useCallback(() => {
//         setOpen(false);
//     }, []);

//     // Memoized components
//     const ChatHeader = useMemo(() => () => (
//         <div className="bg-gradient-to-r from-blue-600 to-emerald-500 p-4 text-white rounded-t-2xl">
//             <div className="flex items-center justify-between">
//                 <div className="flex items-center gap-3">
//                     <div className="relative">
//                         <div className="w-10 h-10 bg-white/20 rounded-xl flex items-center justify-center backdrop-blur-sm">
//                             <Bot className="w-6 h-6" />
//                         </div>
//                         <div className="absolute -bottom-1 -right-1 w-3 h-3 bg-green-500 rounded-full animate-pulse" />
//                     </div>
//                     <div>
//                         <h3 className="font-bold text-lg">Momin's AI Assistant</h3>
//                         <div className="flex items-center gap-1 text-xs text-blue-100">
//                             <Zap className="w-3 h-3" />
//                             <span>Online • Ready to help you grow</span>
//                         </div>
//                     </div>
//                 </div>
//                 <div className="flex items-center gap-2">
//                     <motion.button
//                         whileHover={{ scale: 1.05 }}
//                         whileTap={{ scale: 0.95 }}
//                         onClick={toggleMinimize}
//                         className="p-1.5 hover:bg-white/20 rounded-lg transition-colors"
//                     >
//                         {isMinimized ? <Maximize2 className="w-4 h-4" /> : <Minimize2 className="w-4 h-4" />}
//                     </motion.button>
//                     <motion.button
//                         whileHover={{ scale: 1.05 }}
//                         whileTap={{ scale: 0.95 }}
//                         onClick={closeChat}
//                         className="p-1.5 hover:bg-white/20 rounded-lg transition-colors"
//                     >
//                         <X className="w-4 h-4" />
//                     </motion.button>
//                 </div>
//             </div>
//         </div>
//     ), [isMinimized, toggleMinimize, closeChat]);

//     const ChatMessage = useCallback(({ message }) => {
//         const isBot = message.sender === "bot";

//         return (
//             <motion.div
//                 initial={{ opacity: 0, y: 20 }}
//                 animate={{ opacity: 1, y: 0 }}
//                 className={`flex ${isBot ? "justify-start" : "justify-end"} mb-4`}
//             >
//                 <div className={`flex gap-2 max-w-[85%] ${isBot ? "flex-row" : "flex-row-reverse"}`}>
//                     {isBot && (
//                         <div className="w-8 h-8 rounded-full bg-gradient-to-br from-blue-600 to-emerald-500 flex items-center justify-center flex-shrink-0 shadow-md">
//                             <Bot className="w-4 h-4 text-white" />
//                         </div>
//                     )}

//                     <div className={`relative group ${!isBot && "order-1"}`}>
//                         <div
//                             className={`p-3 rounded-2xl ${isBot
//                                 ? "bg-gradient-to-r from-gray-100 to-gray-50 text-gray-800 rounded-tl-sm shadow-sm"
//                                 : "bg-gradient-to-r from-blue-600 to-emerald-500 text-white rounded-tr-sm shadow-md"
//                                 }`}
//                         >
//                             <p className="text-sm leading-relaxed">{message.text}</p>

//                             <div className={`flex items-center gap-1 mt-2 ${isBot ? "justify-start" : "justify-end"} opacity-0 group-hover:opacity-100 transition-opacity`}>
//                                 {isBot ? (
//                                     <>
//                                         <button onClick={() => copyMessage(message.text, message.id)} className="p-1 hover:bg-gray-200 rounded-lg transition-colors">
//                                             {copiedId === message.id ? <CheckCircle className="w-3 h-3 text-green-500" /> : <Copy className="w-3 h-3 text-gray-500" />}
//                                         </button>
//                                         <button 
//                                             onClick={() => giveFeedback(message.id, 'like')} 
//                                             className={`p-1 hover:bg-gray-200 rounded-lg transition-colors ${feedbackGiven[message.id] === 'like' ? 'text-green-500' : 'text-gray-500'}`}
//                                         >
//                                             <ThumbsUp className="w-3 h-3" />
//                                         </button>
//                                         <button 
//                                             onClick={() => giveFeedback(message.id, 'dislike')} 
//                                             className={`p-1 hover:bg-gray-200 rounded-lg transition-colors ${feedbackGiven[message.id] === 'dislike' ? 'text-red-500' : 'text-gray-500'}`}
//                                         >
//                                             <ThumbsDown className="w-3 h-3" />
//                                         </button>
//                                     </>
//                                 ) : (
//                                     <div className="flex items-center gap-1">
//                                         {message.status === "sending" && <Loader2 className="w-3 h-3 animate-spin text-white/70" />}
//                                         {message.status === "sent" && <CheckCircle className="w-3 h-3 text-white/70" />}
//                                         {message.status === "read" && <CheckCircle className="w-3 h-3 text-green-300" />}
//                                     </div>
//                                 )}
//                             </div>
//                         </div>

//                         <div className={`text-xs text-gray-400 mt-1 ${isBot ? "ml-1" : "mr-1 text-right"}`}>
//                             {formatTime(message.timestamp)}
//                         </div>
//                     </div>

//                     {!isBot && (
//                         <div className="w-8 h-8 rounded-full bg-gradient-to-br from-gray-700 to-gray-800 flex items-center justify-center flex-shrink-0 shadow-md">
//                             <User className="w-4 h-4 text-white" />
//                         </div>
//                     )}
//                 </div>
//             </motion.div>
//         );
//     }, [copiedId, feedbackGiven, copyMessage, giveFeedback, formatTime]);

//     const SuggestionChip = useCallback(({ text, onClick }) => (
//         <motion.button
//             whileHover={{ scale: 1.05, y: -2 }}
//             whileTap={{ scale: 0.95 }}
//             onClick={() => onClick(text)}
//             className="px-3 py-1.5 bg-gradient-to-r from-blue-50 to-emerald-50 text-blue-700 text-xs rounded-full hover:from-blue-100 hover:to-emerald-100 transition-all whitespace-nowrap shadow-sm flex-shrink-0"
//         >
//             {text}
//         </motion.button>
//     ), []);

//     const ChatContent = useMemo(() => () => {
//         const lastMessage = messages[messages.length - 1];
//         const showSuggestions = lastMessage?.sender === "bot" && lastMessage?.suggestions && lastMessage.suggestions.length > 0;

//         return (
//             <div className="flex-1 flex flex-col h-full bg-white">
//                 <div className="flex-1 overflow-y-auto p-4 space-y-3 bg-gradient-to-b from-gray-50 to-white">
//                     {messages.map((message) => (
//                         <ChatMessage key={message.id} message={message} />
//                     ))}

//                     {isTyping && (
//                         <motion.div
//                             initial={{ opacity: 0 }}
//                             animate={{ opacity: 1 }}
//                             className="flex justify-start"
//                         >
//                             <div className="flex gap-2">
//                                 <div className="w-8 h-8 rounded-full bg-gradient-to-br from-blue-600 to-emerald-500 flex items-center justify-center shadow-md">
//                                     <Bot className="w-4 h-4 text-white" />
//                                 </div>
//                                 <div className="bg-gray-100 p-3 rounded-2xl rounded-tl-sm shadow-sm">
//                                     <div className="flex gap-1">
//                                         <div className="w-2 h-2 bg-blue-400 rounded-full animate-bounce" style={{ animationDelay: "0ms" }} />
//                                         <div className="w-2 h-2 bg-blue-400 rounded-full animate-bounce" style={{ animationDelay: "150ms" }} />
//                                         <div className="w-2 h-2 bg-blue-400 rounded-full animate-bounce" style={{ animationDelay: "300ms" }} />
//                                     </div>
//                                 </div>
//                             </div>
//                         </motion.div>
//                     )}

//                     <div ref={messagesEndRef} />
//                 </div>

//                 {showSuggestions && (
//                     <div className="px-4 py-3 border-t border-gray-100 bg-gray-50">
//                         <div className="flex gap-2 overflow-x-auto pb-2 scrollbar-hide">
//                             {lastMessage.suggestions.map((suggestion, idx) => (
//                                 <SuggestionChip key={idx} text={suggestion} onClick={handleSuggestionClick} />
//                             ))}
//                         </div>
//                     </div>
//                 )}

//                 <div className="p-4 border-t border-gray-100 bg-white rounded-b-2xl">
//                     <div className="flex items-center gap-2">
//                         <motion.button
//                             whileTap={{ scale: 0.95 }}
//                             onClick={handleVoiceInput}
//                             className={`p-2.5 rounded-xl transition-all flex-shrink-0 ${isVoiceActive
//                                 ? "bg-red-500 text-white animate-pulse"
//                                 : "bg-gray-100 text-gray-600 hover:bg-gray-200"
//                                 }`}
//                         >
//                             {isVoiceActive ? <VolumeX className="w-5 h-5" /> : <Volume2 className="w-5 h-5" />}
//                         </motion.button>

//                         <input
//                             ref={inputRef}
//                             type="text"
//                             value={inputMessage}
//                             onChange={handleInputChange}
//                             onKeyDown={handleKeyPress}
//                             placeholder="Type your message..."
//                             className="flex-1 px-4 py-2.5 bg-gray-50 border border-gray-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent text-sm text-gray-800 placeholder-gray-400"
//                             disabled={loading}
//                             autoComplete="off"
//                             spellCheck={false}
//                         />

//                         <motion.button
//                             whileHover={{ scale: 1.05 }}
//                             whileTap={{ scale: 0.95 }}
//                             onClick={() => sendMessage()}
//                             disabled={!inputMessage.trim() || loading}
//                             className="p-2.5 bg-gradient-to-r from-blue-600 to-emerald-500 text-white rounded-xl hover:shadow-lg transition-all disabled:opacity-50 disabled:cursor-not-allowed flex-shrink-0"
//                         >
//                             {loading ? <Loader2 className="w-5 h-5 animate-spin" /> : <Send className="w-5 h-5" />}
//                         </motion.button>
//                     </div>

//                     <div className="flex items-center justify-between mt-3">
//                         <p className="text-xs text-gray-400">
//                             Powered by AI • Real-time responses
//                         </p>
//                         <button 
//                             onClick={() => window.location.href = 'https://wa.me/923112891862'}
//                             className="text-xs text-green-600 hover:text-green-700 font-medium flex items-center gap-1"
//                         >
//                             <MessageCircle className="w-3 h-3" />
//                             Contact on WhatsApp
//                         </button>
//                     </div>
//                 </div>
//             </div>
//         );
//     }, [messages, isTyping, inputMessage, loading, isVoiceActive, ChatMessage, SuggestionChip, handleSuggestionClick, handleVoiceInput, handleInputChange, handleKeyPress, sendMessage]);

//     const MinimizedChat = useMemo(() => () => (
//         <motion.div
//             initial={{ opacity: 0, scale: 0.8 }}
//             animate={{ opacity: 1, scale: 1 }}
//             exit={{ opacity: 0, scale: 0.8 }}
//             className="fixed bottom-24 right-5 w-80 bg-white rounded-2xl shadow-2xl border border-blue-100 overflow-hidden"
//         >
//             <div className="bg-gradient-to-r from-blue-600 to-emerald-500 p-3 text-white">
//                 <div className="flex items-center justify-between">
//                     <div className="flex items-center gap-2">
//                         <Bot className="w-5 h-5" />
//                         <div>
//                             <p className="font-semibold text-sm">Momin's AI Assistant</p>
//                             <p className="text-xs text-blue-100">{messages.length} messages</p>
//                         </div>
//                     </div>
//                     <div className="flex items-center gap-2">
//                         <motion.button
//                             whileHover={{ scale: 1.05 }}
//                             whileTap={{ scale: 0.95 }}
//                             onClick={toggleMinimize}
//                             className="p-1 hover:bg-white/20 rounded-lg"
//                         >
//                             <Maximize2 className="w-4 h-4" />
//                         </motion.button>
//                         <motion.button
//                             whileHover={{ scale: 1.05 }}
//                             whileTap={{ scale: 0.95 }}
//                             onClick={closeChat}
//                             className="p-1 hover:bg-white/20 rounded-lg"
//                         >
//                             <X className="w-4 h-4" />
//                         </motion.button>
//                     </div>
//                 </div>
//             </div>
//             <div className="p-3 bg-gray-50">
//                 <div className="flex items-center gap-2">
//                     <div className="flex-1 bg-white border border-gray-200 rounded-xl px-3 py-2">
//                         <p className="text-xs text-gray-500 truncate">
//                             {messages[messages.length - 1]?.text || "Click to continue chatting..."}
//                         </p>
//                     </div>
//                     <div className="w-2 h-2 bg-green-500 rounded-full animate-pulse" />
//                 </div>
//             </div>
//         </motion.div>
//     ), [messages.length, toggleMinimize, closeChat]);

//     return (
//         <>
//             {/* Floating Button */}
//             <motion.div
//                 initial={{ scale: 0 }}
//                 animate={{ scale: 1 }}
//                 whileHover={{ scale: 1.1 }}
//                 whileTap={{ scale: 0.9 }}
//                 onClick={toggleChat}
//                 className="fixed bottom-6 right-6 z-50 cursor-pointer group"
//             >
//                 <div className="absolute inset-0 bg-gradient-to-r from-blue-600 to-emerald-500 rounded-full blur-lg opacity-60 group-hover:opacity-100 transition-opacity" />
//                 <div className="relative w-14 h-14 bg-gradient-to-r from-blue-600 to-emerald-500 rounded-full flex items-center justify-center shadow-xl group-hover:shadow-2xl transition-all">
//                     <MessageCircle className="w-6 h-6 text-white" />
//                     <div className="absolute -top-1 -right-1 w-4 h-4 bg-green-500 rounded-full animate-pulse border-2 border-white" />
//                     {messages.filter(m => m.sender === "bot" && m.id !== "1").length > 0 && (
//                         <span className="absolute -top-2 -right-2 px-1.5 py-0.5 bg-red-500 text-white text-xs rounded-full">
//                             {messages.filter(m => m.sender === "bot" && m.id !== "1").length}
//                         </span>
//                     )}
//                 </div>
//             </motion.div>

//             {/* Chat Window */}
//             <AnimatePresence>
//                 {open && (
//                     <motion.div
//                         initial={{ opacity: 0, y: 50, scale: 0.9 }}
//                         animate={{ opacity: 1, y: 0, scale: 1 }}
//                         exit={{ opacity: 0, y: 50, scale: 0.9 }}
//                         transition={{ type: "spring", damping: 25 }}
//                         className="fixed bottom-24 right-6 z-50"
//                     >
//                         {isMinimized ? (
//                             <MinimizedChat />
//                         ) : (
//                             <div className="w-[420px] h-[650px] bg-white rounded-2xl shadow-2xl overflow-hidden flex flex-col">
//                                 <ChatHeader />
//                                 <ChatContent />
//                             </div>
//                         )}
//                     </motion.div>
//                 )}
//             </AnimatePresence>
//         </>
//     );
// }


// import { useState, useRef, useEffect } from "react";
// import { motion, AnimatePresence } from "framer-motion";
// import { 
//   Bot, Send, X, Minimize2, Maximize2, 
//   MessageCircle, User, Loader2, Sparkles,
//   Zap, CheckCircle, Clock, Volume2, VolumeX,
//   Copy, ThumbsUp, ThumbsDown, RefreshCw,
//   Mic, Paperclip, Smile, MoreHorizontal
// } from "lucide-react";

// export default function ChatbotWidget() {
//   const [open, setOpen] = useState(false);
//   const [isMinimized, setIsMinimized] = useState(false);
//   const [loading, setLoading] = useState(false);
//   const [messages, setMessages] = useState([
//     {
//       id: "1",
//       text: "👋 Hi there! I'm your AI assistant. How can I help you today?",
//       sender: "bot",
//       timestamp: new Date(),
//       suggestions: [
//         "Create a website",
//         "Pricing plans",
//         "Technical support",
//         "Book a demo"
//       ]
//     }
//   ]);
//   const [inputMessage, setInputMessage] = useState("");
//   const [isTyping, setIsTyping] = useState(false);
//   const [isVoiceActive, setIsVoiceActive] = useState(false);
//   const [isRecording, setIsRecording] = useState(false);
//   const messagesEndRef = useRef(null);
//   const inputRef = useRef(null);

//   // Auto-scroll to bottom
//   useEffect(() => {
//     messagesEndRef.current?.scrollIntoView({ behavior: "smooth" });
//   }, [messages]);

//   // Focus input when chat opens
//   useEffect(() => {
//     if (open && !isMinimized) {
//       setTimeout(() => inputRef.current?.focus(), 300);
//     }
//   }, [open, isMinimized]);

//   const sendMessage = async (messageText) => {
//     const textToSend = messageText || inputMessage;
//     if (!textToSend.trim()) return;

//     // Add user message
//     const userMessage = {
//       id: Date.now().toString(),
//       text: textToSend,
//       sender: "user",
//       timestamp: new Date(),
//       status: "sending"
//     };
//     setMessages(prev => [...prev, userMessage]);
//     setInputMessage("");
//     setLoading(true);
//     setIsTyping(true);

//     try {
//       const res = await fetch("http://localhost:4000/message/create", {
//         method: "POST",
//         headers: {
//           "Content-Type": "application/json",
//         },
//         body: JSON.stringify({ message: textToSend }),
//       });

//       const data = await res.json();

//       // Update user message status
//       setMessages(prev => prev.map(msg => 
//         msg.id === userMessage.id ? { ...msg, status: "read" } : msg
//       ));

//       // Add bot response
//       const botMessage = {
//         id: (Date.now() + 1).toString(),
//         text: data?.data?.reply || "I'll help you with that. Could you please provide more details?",
//         sender: "bot",
//         timestamp: new Date(),
//         suggestions: getSuggestionsForMessage(textToSend)
//       };
//       setMessages(prev => [...prev, botMessage]);
//     } catch (err) {
//       console.error(err);
//       // Add error message
//       const errorMessage = {
//         id: (Date.now() + 1).toString(),
//         text: "Sorry, I'm having trouble connecting. Please try again later.",
//         sender: "bot",
//         timestamp: new Date(),
//       };
//       setMessages(prev => [...prev, errorMessage]);
//     } finally {
//       setLoading(false);
//       setIsTyping(false);
//     }
//   };

//   const getSuggestionsForMessage = (message) => {
//     const lowerMsg = message.toLowerCase();
//     if (lowerMsg.includes("website") || lowerMsg.includes("create")) {
//       return ["What's your budget?", "Timeline?", "See portfolio", "Get quote"];
//     }
//     if (lowerMsg.includes("price") || lowerMsg.includes("cost")) {
//       return ["Basic: $499", "Pro: $999", "Enterprise: Custom", "Request demo"];
//     }
//     if (lowerMsg.includes("support") || lowerMsg.includes("help")) {
//       return ["FAQ", "Contact support", "Live chat", "Email us"];
//     }
//     return ["Tell me more", "Show examples", "Get started", "Learn more"];
//   };

//   const handleKeyPress = (e) => {
//     if (e.key === "Enter" && !e.shiftKey) {
//       e.preventDefault();
//       sendMessage();
//     }
//   };

//   const formatTime = (date) => {
//     return date.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
//   };

//   const handleVoiceInput = () => {
//     setIsVoiceActive(!isVoiceActive);
//     setIsRecording(true);
//     // Simulate voice recognition
//     setTimeout(() => {
//       setInputMessage("I need help with creating a website");
//       setIsVoiceActive(false);
//       setIsRecording(false);
//     }, 3000);
//   };

//   const copyMessage = (text) => {
//     navigator.clipboard.writeText(text);
//     // You can add a toast notification here
//   };

//   const ChatHeader = () => (
//     <div className="bg-gradient-to-r from-blue-600 to-blue-500 p-4 text-white rounded-t-2xl">
//       <div className="flex items-center justify-between">
//         <div className="flex items-center gap-3">
//           <div className="relative">
//             <div className="w-10 h-10 bg-white/20 rounded-xl flex items-center justify-center backdrop-blur-sm">
//               <Bot className="w-6 h-6" />
//             </div>
//             <div className="absolute -bottom-1 -right-1 w-3 h-3 bg-green-500 rounded-full animate-pulse" />
//           </div>
//           <div>
//             <h3 className="font-bold">AI Assistant</h3>
//             <div className="flex items-center gap-1 text-xs text-blue-100">
//               <Zap className="w-3 h-3" />
//               <span>Online • Ready to help</span>
//             </div>
//           </div>
//         </div>
//         <div className="flex items-center gap-2">
//           <motion.button
//             whileHover={{ scale: 1.05 }}
//             whileTap={{ scale: 0.95 }}
//             onClick={() => setIsMinimized(!isMinimized)}
//             className="p-1.5 hover:bg-white/20 rounded-lg transition-colors"
//           >
//             {isMinimized ? <Maximize2 className="w-4 h-4" /> : <Minimize2 className="w-4 h-4" />}
//           </motion.button>
//           <motion.button
//             whileHover={{ scale: 1.05 }}
//             whileTap={{ scale: 0.95 }}
//             onClick={() => setOpen(false)}
//             className="p-1.5 hover:bg-white/20 rounded-lg transition-colors"
//           >
//             <X className="w-4 h-4" />
//           </motion.button>
//         </div>
//       </div>
//     </div>
//   );

//   const ChatMessage = ({ message }) => {
//     const isBot = message.sender === "bot";

//     return (
//       <motion.div
//         initial={{ opacity: 0, y: 20 }}
//         animate={{ opacity: 1, y: 0 }}
//         className={`flex ${isBot ? "justify-start" : "justify-end"} mb-3`}
//       >
//         <div className={`flex gap-2 max-w-[80%] ${isBot ? "flex-row" : "flex-row-reverse"}`}>
//           {isBot && (
//             <div className="w-8 h-8 rounded-full bg-gradient-to-br from-blue-600 to-blue-500 flex items-center justify-center flex-shrink-0 shadow-md">
//               <Bot className="w-4 h-4 text-white" />
//             </div>
//           )}

//           <div className={`relative group ${!isBot && "order-1"}`}>
//             <div
//               className={`p-3 rounded-2xl ${
//                 isBot
//                   ? "bg-gray-100 text-gray-800 rounded-tl-sm"
//                   : "bg-gradient-to-r from-blue-600 to-blue-500 text-white rounded-tr-sm"
//               }`}
//             >
//               <p className="text-sm leading-relaxed">{message.text}</p>

//               {/* Message Actions */}
//               <div className={`flex items-center gap-1 mt-2 ${isBot ? "justify-start" : "justify-end"} opacity-0 group-hover:opacity-100 transition-opacity`}>
//                 {isBot ? (
//                   <>
//                     <button onClick={() => copyMessage(message.text)} className="p-1 hover:bg-gray-200 rounded-lg transition-colors">
//                       <Copy className="w-3 h-3 text-gray-500" />
//                     </button>
//                     <button className="p-1 hover:bg-gray-200 rounded-lg transition-colors">
//                       <ThumbsUp className="w-3 h-3 text-gray-500" />
//                     </button>
//                     <button className="p-1 hover:bg-gray-200 rounded-lg transition-colors">
//                       <ThumbsDown className="w-3 h-3 text-gray-500" />
//                     </button>
//                   </>
//                 ) : (
//                   <div className="flex items-center gap-1">
//                     {message.status === "sending" && <Loader2 className="w-3 h-3 animate-spin text-white/70" />}
//                     {message.status === "sent" && <CheckCircle className="w-3 h-3 text-white/70" />}
//                     {message.status === "read" && <CheckCircle className="w-3 h-3 text-green-300" />}
//                   </div>
//                 )}
//               </div>
//             </div>

//             {/* Timestamp */}
//             <div className={`text-xs text-gray-400 mt-1 ${isBot ? "ml-1" : "mr-1 text-right"}`}>
//               {formatTime(message.timestamp)}
//             </div>
//           </div>

//           {!isBot && (
//             <div className="w-8 h-8 rounded-full bg-gradient-to-br from-green-600 to-green-500 flex items-center justify-center flex-shrink-0 shadow-md">
//               <User className="w-4 h-4 text-white" />
//             </div>
//           )}
//         </div>
//       </motion.div>
//     );
//   };

//   const SuggestionChip = ({ text, onClick }) => (
//     <motion.button
//       whileHover={{ scale: 1.05 }}
//       whileTap={{ scale: 0.95 }}
//       onClick={onClick}
//       className="px-3 py-1.5 bg-blue-50 text-blue-700 text-xs rounded-full hover:bg-blue-100 transition-colors whitespace-nowrap"
//     >
//       {text}
//     </motion.button>
//   );

//   const ChatContent = () => (
//     <div className="flex-1 flex flex-col h-full">
//       {/* Messages Area */}
//       <div className="flex-1 overflow-y-auto p-4 space-y-3">
//         {messages.map((message) => (
//           <ChatMessage key={message.id} message={message} />
//         ))}

//         {isTyping && (
//           <motion.div
//             initial={{ opacity: 0 }}
//             animate={{ opacity: 1 }}
//             className="flex justify-start"
//           >
//             <div className="flex gap-2">
//               <div className="w-8 h-8 rounded-full bg-gradient-to-br from-blue-600 to-blue-500 flex items-center justify-center shadow-md">
//                 <Bot className="w-4 h-4 text-white" />
//               </div>
//               <div className="bg-gray-100 p-3 rounded-2xl rounded-tl-sm">
//                 <div className="flex gap-1">
//                   <div className="w-2 h-2 bg-gray-400 rounded-full animate-bounce" style={{ animationDelay: "0ms" }} />
//                   <div className="w-2 h-2 bg-gray-400 rounded-full animate-bounce" style={{ animationDelay: "150ms" }} />
//                   <div className="w-2 h-2 bg-gray-400 rounded-full animate-bounce" style={{ animationDelay: "300ms" }} />
//                 </div>
//               </div>
//             </div>
//           </motion.div>
//         )}

//         <div ref={messagesEndRef} />
//       </div>

//       {/* Suggestions */}
//       {messages[messages.length - 1]?.sender === "bot" && messages[messages.length - 1]?.suggestions && (
//         <div className="px-4 py-2 border-t border-gray-100">
//           <div className="flex gap-2 overflow-x-auto pb-2 scrollbar-hide">
//             {messages[messages.length - 1].suggestions.map((suggestion, idx) => (
//               <SuggestionChip key={idx} text={suggestion} onClick={() => sendMessage(suggestion)} />
//             ))}
//           </div>
//         </div>
//       )}

//       {/* Input Area */}
//       <div className="p-4 border-t border-gray-100 bg-gray-50 rounded-b-2xl">
//         <div className="flex items-center gap-2">
//           <motion.button
//             whileTap={{ scale: 0.95 }}
//             onClick={handleVoiceInput}
//             className={`p-2.5 rounded-xl transition-all ${
//               isVoiceActive || isRecording
//                 ? "bg-red-500 text-white animate-pulse" 
//                 : "bg-gray-200 text-gray-600 hover:bg-gray-300"
//             }`}
//           >
//             <Mic className="w-5 h-5" />
//           </motion.button>

//           <motion.button
//             whileTap={{ scale: 0.95 }}
//             className="p-2.5 rounded-xl bg-gray-200 text-gray-600 hover:bg-gray-300 transition-all"
//           >
//             <Paperclip className="w-5 h-5" />
//           </motion.button>

//           <input
//             ref={inputRef}
//             type="text"
//             value={inputMessage}
//             onChange={(e) => setInputMessage(e.target.value)}
//             onKeyPress={handleKeyPress}
//             placeholder="Type your message..."
//             className="flex-1 px-4 py-2.5 bg-white border border-gray-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent text-sm"
//             disabled={loading}
//           />

//           <motion.button
//             whileHover={{ scale: 1.05 }}
//             whileTap={{ scale: 0.95 }}
//             onClick={() => sendMessage()}
//             disabled={!inputMessage.trim() || loading}
//             className="p-2.5 bg-gradient-to-r from-blue-600 to-blue-500 text-white rounded-xl hover:shadow-lg transition-all disabled:opacity-50 disabled:cursor-not-allowed"
//           >
//             {loading ? <Loader2 className="w-5 h-5 animate-spin" /> : <Send className="w-5 h-5" />}
//           </motion.button>
//         </div>

//         <div className="flex items-center justify-between mt-3">
//           <p className="text-xs text-gray-400">
//             Powered by AI • Responses are generated in real-time
//           </p>
//           <div className="flex items-center gap-1">
//             <div className="w-2 h-2 bg-green-500 rounded-full animate-pulse" />
//             <span className="text-xs text-gray-400">Active</span>
//           </div>
//         </div>
//       </div>
//     </div>
//   );

//   const MinimizedChat = () => (
//     <motion.div
//       initial={{ opacity: 0, scale: 0.8 }}
//       animate={{ opacity: 1, scale: 1 }}
//       exit={{ opacity: 0, scale: 0.8 }}
//       className="fixed bottom-24 right-5 w-80 bg-white rounded-2xl shadow-2xl border border-blue-100 overflow-hidden"
//     >
//       <div className="bg-gradient-to-r from-blue-600 to-blue-500 p-3 text-white">
//         <div className="flex items-center justify-between">
//           <div className="flex items-center gap-2">
//             <div className="relative">
//               <Bot className="w-5 h-5" />
//               <div className="absolute -top-1 -right-1 w-2 h-2 bg-green-400 rounded-full animate-pulse" />
//             </div>
//             <div>
//               <p className="font-semibold text-sm">AI Assistant</p>
//               <p className="text-xs text-blue-100">{messages.length} messages</p>
//             </div>
//           </div>
//           <div className="flex items-center gap-2">
//             <motion.button
//               whileHover={{ scale: 1.05 }}
//               whileTap={{ scale: 0.95 }}
//               onClick={() => setIsMinimized(false)}
//               className="p-1 hover:bg-white/20 rounded-lg"
//             >
//               <Maximize2 className="w-4 h-4" />
//             </motion.button>
//             <motion.button
//               whileHover={{ scale: 1.05 }}
//               whileTap={{ scale: 0.95 }}
//               onClick={() => setOpen(false)}
//               className="p-1 hover:bg-white/20 rounded-lg"
//             >
//               <X className="w-4 h-4" />
//             </motion.button>
//           </div>
//         </div>
//       </div>
//       <div className="p-3 bg-gray-50">
//         <div className="flex items-center gap-2">
//           <div className="flex-1 bg-white border border-gray-200 rounded-xl px-3 py-2">
//             <p className="text-xs text-gray-500 truncate">
//               {messages[messages.length - 1]?.text || "Click to continue chatting..."}
//             </p>
//           </div>
//           <div className="w-2 h-2 bg-green-500 rounded-full animate-pulse" />
//         </div>
//       </div>
//     </motion.div>
//   );

//   return (
//     <>
//       {/* Floating Button */}
//       <motion.div
//         initial={{ scale: 0 }}
//         animate={{ scale: 1 }}
//         whileHover={{ scale: 1.1 }}
//         whileTap={{ scale: 0.9 }}
//         onClick={() => setOpen(true)}
//         className="fixed bottom-6 right-6 z-50 cursor-pointer group"
//       >
//         {/* Glow Effect */}
//         <div className="absolute inset-0 bg-gradient-to-r from-blue-600 to-blue-500 rounded-full blur-lg opacity-60 group-hover:opacity-100 transition-opacity" />

//         {/* Main Button */}
//         <div className="relative w-14 h-14 bg-gradient-to-r from-blue-600 to-blue-500 rounded-full flex items-center justify-center shadow-xl group-hover:shadow-2xl transition-all">
//           <MessageCircle className="w-6 h-6 text-white" />

//           {/* Online Status Indicator */}
//           <div className="absolute -top-1 -right-1 w-4 h-4 bg-green-500 rounded-full animate-pulse border-2 border-white" />

//           {/* Message Count Badge */}
//           {messages.filter(m => m.sender === "bot" && !m.id.includes("error")).length > 0 && (
//             <span className="absolute -top-2 -right-2 px-1.5 py-0.5 bg-red-500 text-white text-xs rounded-full">
//               {messages.filter(m => m.sender === "bot" && !m.id.includes("error")).length}
//             </span>
//           )}
//         </div>
//       </motion.div>

//       {/* Chat Window */}
//       <AnimatePresence>
//         {open && (
//           <motion.div
//             initial={{ opacity: 0, y: 50, scale: 0.9 }}
//             animate={{ opacity: 1, y: 0, scale: 1 }}
//             exit={{ opacity: 0, y: 50, scale: 0.9 }}
//             transition={{ type: "spring", damping: 25 }}
//             className="fixed bottom-24 right-6 z-50"
//           >
//             {isMinimized ? (
//               <MinimizedChat />
//             ) : (
//               <div className="w-[400px] h-[600px] bg-white rounded-2xl shadow-2xl overflow-hidden flex flex-col">
//                 <ChatHeader />
//                 <ChatContent />
//               </div>
//             )}
//           </motion.div>
//         )}
//       </AnimatePresence>

//       {/* Custom Scrollbar Styles */}
//       <style jsx>{`
//         .scrollbar-hide::-webkit-scrollbar {
//           display: none;
//         }
//         .scrollbar-hide {
//           -ms-overflow-style: none;
//           scrollbar-width: none;
//         }
//       `}</style>
//     </>
//   );
// }


// import { useState, useRef, useEffect } from "react";
// import { motion, AnimatePresence } from "framer-motion";
// import { 
//   Bot, Send, X, Minimize2, Maximize2, 
//   MessageCircle, User, Loader2, Sparkles,
//   Zap, CheckCircle, Clock, Volume2, VolumeX,
//   Copy, ThumbsUp, ThumbsDown, RefreshCw,
//   Mic, Paperclip, Smile, MoreHorizontal
// } from "lucide-react";

// const ChatbotWidget = () => {
//   const [isOpen, setIsOpen] = useState(false);
//   const [isMinimized, setIsMinimized] = useState(false);
//   const [messages, setMessages] = useState([
//     {
//       id: 1,
//       type: "bot",
//       text: "Hello! I'm your AI assistant. How can I help you today?",
//       timestamp: new Date(),
//     },
//   ]);
//   const [inputValue, setInputValue] = useState("");
//   const [isTyping, setIsTyping] = useState(false);
//   const [isListening, setIsListening] = useState(false);
//   const [isMuted, setIsMuted] = useState(false);
//   const messagesEndRef = useRef(null);
//   const inputRef = useRef(null);

//   // Auto-scroll to bottom of messages
//   useEffect(() => {
//     messagesEndRef.current?.scrollIntoView({ behavior: "smooth" });
//   }, [messages]);

//   // Focus input when chat opens
//   useEffect(() => {
//     if (isOpen && !isMinimized) {
//       inputRef.current?.focus();
//     }
//   }, [isOpen, isMinimized]);

//   // Sample bot responses
//   const botResponses = [
//     "That's interesting! Tell me more.",
//     "I understand. How can I assist you further?",
//     "Thanks for sharing. Is there anything else you'd like to know?",
//     "Great question! Let me think about that for a moment.",
//     "I'm here to help! What specific information do you need?",
//   ];

//   const handleSendMessage = async () => {
//     if (!inputValue.trim()) return;

//     // Add user message
//     const userMessage = {
//       id: Date.now(),
//       type: "user",
//       text: inputValue,
//       timestamp: new Date(),
//     };
//     setMessages((prev) => [...prev, userMessage]);
//     setInputValue("");
//     setIsTyping(true);

//     // Simulate bot response
//     setTimeout(() => {
//       const randomResponse =
//         botResponses[Math.floor(Math.random() * botResponses.length)];
//       const botMessage = {
//         id: Date.now() + 1,
//         type: "bot",
//         text: randomResponse,
//         timestamp: new Date(),
//       };
//       setMessages((prev) => [...prev, botMessage]);
//       setIsTyping(false);

//       // Play sound if not muted
//       if (!isMuted) {
//         // Optional: Add sound effect here
//       }
//     }, 1500);
//   };

//   const handleKeyPress = (e) => {
//     if (e.key === "Enter" && !e.shiftKey) {
//       e.preventDefault();
//       handleSendMessage();
//     }
//   };

//   const clearChat = () => {
//     setMessages([
//       {
//         id: Date.now(),
//         type: "bot",
//         text: "Chat cleared! How can I help you?",
//         timestamp: new Date(),
//       },
//     ]);
//   };

//   const copyLastBotMessage = () => {
//     const lastBotMessage = [...messages].reverse().find(m => m.type === "bot");
//     if (lastBotMessage) {
//       navigator.clipboard.writeText(lastBotMessage.text);
//       // Optional: Show toast notification
//     }
//   };

//   const formatTime = (date) => {
//     return date.toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" });
//   };

//   // Voice recognition simulation
//   const toggleVoiceInput = () => {
//     setIsListening(!isListening);
//     if (!isListening) {
//       // Simulate voice input
//       setTimeout(() => {
//         setInputValue("I need help with something...");
//         setIsListening(false);
//       }, 2000);
//     }
//   };

//   return (
//     <>
//       {/* Chatbot Toggle Button - Circular */}
//       <motion.button
//         onClick={() => setIsOpen(true)}
//         className="fixed right-6 bottom-6 z-50 w-14 h-14 rounded-full bg-gradient-to-r from-blue-600 to-blue-500 text-white shadow-lg hover:shadow-xl transition-all duration-300 flex items-center justify-center group"
//         whileHover={{ scale: 1.1 }}
//         whileTap={{ scale: 0.95 }}
//         initial={{ scale: 0 }}
//         animate={{ scale: 1 }}
//         transition={{ type: "spring", stiffness: 260, damping: 20 }}
//       >
//         <MessageCircle className="w-6 h-6 group-hover:rotate-12 transition-transform" />
//         <span className="absolute -top-1 -right-1 w-4 h-4 bg-green-400 rounded-full border-2 border-white animate-pulse" />
//       </motion.button>

//       {/* Chatbot Window */}
//       <AnimatePresence>
//         {isOpen && (
//           <motion.div
//             initial={{ opacity: 0, y: 50, scale: 0.9 }}
//             animate={{ 
//               opacity: 1, 
//               y: 0, 
//               scale: 1,
//               ...(isMinimized && { 
//                 height: "60px",
//                 width: "320px",
//               })
//             }}
//             exit={{ opacity: 0, y: 50, scale: 0.9 }}
//             transition={{ type: "spring", damping: 25, stiffness: 300 }}
//             className={`fixed right-6 bottom-24 z-50 bg-white rounded-2xl shadow-2xl overflow-hidden border border-gray-100 ${
//               isMinimized ? "h-14" : "h-[550px] w-[380px]"
//             } w-[380px] flex flex-col`}
//           >
//             {/* Header - Gradient */}
//             <div className="bg-gradient-to-r from-blue-600 via-emerald-500 to-blue-600 bg-size-200 animate-gradient px-4 py-3 flex items-center justify-between text-white">
//               <div className="flex items-center gap-2">
//                 <div className="w-8 h-8 rounded-full bg-white/20 flex items-center justify-center">
//                   <Bot className="w-5 h-5" />
//                 </div>
//                 <div>
//                   <h3 className="font-semibold text-sm">AI Assistant</h3>
//                   <div className="flex items-center gap-1 text-xs text-white/80">
//                     <span className="w-2 h-2 rounded-full bg-green-300 animate-pulse" />
//                     Online
//                   </div>
//                 </div>
//               </div>
//               <div className="flex items-center gap-1">
//                 <button
//                   onClick={() => setIsMinimized(!isMinimized)}
//                   className="p-1.5 hover:bg-white/20 rounded-lg transition-colors"
//                 >
//                   {isMinimized ? <Maximize2 className="w-4 h-4" /> : <Minimize2 className="w-4 h-4" />}
//                 </button>
//                 <button
//                   onClick={() => setIsOpen(false)}
//                   className="p-1.5 hover:bg-white/20 rounded-lg transition-colors"
//                 >
//                   <X className="w-4 h-4" />
//                 </button>
//               </div>
//             </div>

//             {/* Chat Body - Only show when not minimized */}
//             {!isMinimized && (
//               <>
//                 {/* Messages Area */}
//                 <div className="flex-1 overflow-y-auto p-4 space-y-3 bg-gradient-to-b from-gray-50 to-white">
//                   {messages.map((message) => (
//                     <motion.div
//                       key={message.id}
//                       initial={{ opacity: 0, y: 20, x: message.type === "user" ? 20 : -20 }}
//                       animate={{ opacity: 1, y: 0, x: 0 }}
//                       className={`flex ${message.type === "user" ? "justify-end" : "justify-start"}`}
//                     >
//                       <div
//                         className={`max-w-[80%] rounded-2xl px-3 py-2 ${
//                           message.type === "user"
//                             ? "bg-gradient-to-r from-blue-600 to-blue-500 text-white rounded-br-sm"
//                             : "bg-white border border-gray-200 text-gray-700 rounded-bl-sm shadow-sm"
//                         }`}
//                       >
//                         <div className="flex items-start gap-2">
//                           {message.type === "bot" && (
//                             <Bot className="w-4 h-4 mt-0.5 text-blue-500" />
//                           )}
//                           <div>
//                             <p className="text-sm">{message.text}</p>
//                             <div className="flex items-center gap-2 mt-1">
//                               <span className="text-[10px] opacity-70">
//                                 {formatTime(message.timestamp)}
//                               </span>
//                               {message.type === "bot" && (
//                                 <div className="flex items-center gap-1">
//                                   <button
//                                     onClick={copyLastBotMessage}
//                                     className="opacity-50 hover:opacity-100 transition"
//                                   >
//                                     <Copy className="w-3 h-3" />
//                                   </button>
//                                   <button className="opacity-50 hover:opacity-100 transition">
//                                     <ThumbsUp className="w-3 h-3" />
//                                   </button>
//                                   <button className="opacity-50 hover:opacity-100 transition">
//                                     <ThumbsDown className="w-3 h-3" />
//                                   </button>
//                                 </div>
//                               )}
//                             </div>
//                           </div>
//                         </div>
//                       </div>
//                     </motion.div>
//                   ))}

//                   {/* Typing Indicator */}
//                   {isTyping && (
//                     <motion.div
//                       initial={{ opacity: 0 }}
//                       animate={{ opacity: 1 }}
//                       className="flex justify-start"
//                     >
//                       <div className="bg-white border border-gray-200 rounded-2xl rounded-bl-sm px-4 py-2 shadow-sm">
//                         <div className="flex gap-1">
//                           <span className="w-2 h-2 bg-gray-400 rounded-full animate-bounce" style={{ animationDelay: "0ms" }} />
//                           <span className="w-2 h-2 bg-gray-400 rounded-full animate-bounce" style={{ animationDelay: "150ms" }} />
//                           <span className="w-2 h-2 bg-gray-400 rounded-full animate-bounce" style={{ animationDelay: "300ms" }} />
//                         </div>
//                       </div>
//                     </motion.div>
//                   )}
//                   <div ref={messagesEndRef} />
//                 </div>

//                 {/* Quick Actions */}
//                 <div className="px-4 py-2 border-t border-gray-100 bg-gray-50">
//                   <div className="flex items-center gap-2 overflow-x-auto pb-1">
//                     <button className="px-3 py-1 text-xs bg-white rounded-full border border-gray-200 hover:border-blue-300 hover:bg-blue-50 transition whitespace-nowrap flex items-center gap-1">
//                       <Sparkles className="w-3 h-3" />
//                       Help
//                     </button>
//                     <button className="px-3 py-1 text-xs bg-white rounded-full border border-gray-200 hover:border-blue-300 hover:bg-blue-50 transition whitespace-nowrap flex items-center gap-1">
//                       <Zap className="w-3 h-3" />
//                       Features
//                     </button>
//                     <button className="px-3 py-1 text-xs bg-white rounded-full border border-gray-200 hover:border-blue-300 hover:bg-blue-50 transition whitespace-nowrap flex items-center gap-1">
//                       <Clock className="w-3 h-3" />
//                       Hours
//                     </button>
//                     <button onClick={clearChat} className="px-3 py-1 text-xs bg-white rounded-full border border-gray-200 hover:border-blue-300 hover:bg-blue-50 transition whitespace-nowrap flex items-center gap-1">
//                       <RefreshCw className="w-3 h-3" />
//                       Clear
//                     </button>
//                   </div>
//                 </div>

//                 {/* Input Area */}
//                 <div className="p-3 border-t border-gray-100 bg-white">
//                   <div className="flex items-center gap-2">
//                     <button
//                       onClick={toggleVoiceInput}
//                       className={`p-2 rounded-full transition-colors ${
//                         isListening ? "bg-red-100 text-red-500" : "text-gray-400 hover:text-gray-600 hover:bg-gray-100"
//                       }`}
//                     >
//                       <Mic className="w-5 h-5" />
//                     </button>
//                     <button className="p-2 rounded-full text-gray-400 hover:text-gray-600 hover:bg-gray-100 transition-colors">
//                       <Paperclip className="w-5 h-5" />
//                     </button>
//                     <button className="p-2 rounded-full text-gray-400 hover:text-gray-600 hover:bg-gray-100 transition-colors">
//                       <Smile className="w-5 h-5" />
//                     </button>
//                     <div className="flex-1 relative">
//                       <textarea
//                         ref={inputRef}
//                         value={inputValue}
//                         onChange={(e) => setInputValue(e.target.value)}
//                         onKeyPress={handleKeyPress}
//                         placeholder="Type your message..."
//                         rows="1"
//                         className="w-full px-3 py-2 text-sm bg-gray-100 rounded-xl border border-transparent focus:border-blue-300 focus:outline-none focus:ring-2 focus:ring-blue-200 resize-none"
//                         style={{ minHeight: "40px", maxHeight: "100px" }}
//                       />
//                     </div>
//                     <button
//                       onClick={handleSendMessage}
//                       disabled={!inputValue.trim()}
//                       className={`p-2 rounded-full transition-colors ${
//                         inputValue.trim()
//                           ? "bg-gradient-to-r from-blue-600 to-blue-500 text-white shadow-md hover:shadow-lg"
//                           : "text-gray-400 bg-gray-100"
//                       }`}
//                     >
//                       <Send className="w-5 h-5" />
//                     </button>
//                     <button
//                       onClick={() => setIsMuted(!isMuted)}
//                       className="p-2 rounded-full text-gray-400 hover:text-gray-600 hover:bg-gray-100 transition-colors"
//                     >
//                       {isMuted ? <VolumeX className="w-5 h-5" /> : <Volume2 className="w-5 h-5" />}
//                     </button>
//                   </div>
//                 </div>
//               </>
//             )}
//           </motion.div>
//         )}
//       </AnimatePresence>

//       {/* Add custom gradient animation CSS */}
//       <style>{`
//         @keyframes gradient {
//           0% { background-position: 0% 50%; }
//           50% { background-position: 100% 50%; }
//           100% { background-position: 0% 50%; }
//         }
//         .animate-gradient {
//           background-size: 200% 200%;
//           animation: gradient 3s ease infinite;
//         }
//       `}</style>
//     </>
//   );
// };

// export default ChatbotWidget;


import { useState, useRef, useEffect, useCallback } from "react";
import { motion, AnimatePresence } from "framer-motion";
import {
    Bot, Send, X, Sparkles,
    Zap, Clock,
    Copy, ThumbsUp,
    Shield, Wifi, WifiOff,
    FileText, Image, Link2, Download, Trash2,
    Edit2, Star, Share2, Settings
} from "lucide-react";
import { BASE_URL } from "../service/config";

const ChatbotWidget = () => {
    // State Management
    const [isOpen, setIsOpen] = useState(false);
    const [isMinimized, setIsMinimized] = useState(false);
    const [isExpanded, setIsExpanded] = useState(false);
    const [messages, setMessages] = useState([]);
    const [inputValue, setInputValue] = useState("");
    const [isTyping, setIsTyping] = useState(false);
    const [isListening, setIsListening] = useState(false);
    const [isMuted, setIsMuted] = useState(false);
    const [isOnline, setIsOnline] = useState(true);
    const [unreadCount, setUnreadCount] = useState(0);
    const [showSettings, setShowSettings] = useState(false);
    const [showEmojiPicker, setShowEmojiPicker] = useState(false);
    const [editingMessage, setEditingMessage] = useState(null);
    const [searchQuery, setSearchQuery] = useState("");
    const [filterType, setFilterType] = useState("all");
    const [darkMode, setDarkMode] = useState(false);
    const [fontSize, setFontSize] = useState("medium");
    const [language, setLanguage] = useState("en");
    const [suggestions, setSuggestions] = useState([]);
    const [uploadedFiles, setUploadedFiles] = useState([]);
    const [isRecording, setIsRecording] = useState(false);
    const [recordingTime, setRecordingTime] = useState(0);

    // Refs
    const messagesEndRef = useRef(null);
    const inputRef = useRef(null);
    const fileInputRef = useRef(null);
    const chatContainerRef = useRef(null);
    const recordingIntervalRef = useRef(null);

    // Welcome message
    useEffect(() => {
        const welcomeMessage = {
            id: Date.now(),
            type: "bot",
            text: "👋 Welcome! I'm your AI assistant. How can I enhance your experience today?",
            timestamp: new Date(),
            status: "read",
            reactions: { likes: 0, dislikes: 0 },
            starred: false
        };
        setMessages([welcomeMessage]);
    }, []);

    // Enhanced bot responses with categories
    const botResponses = {
        greeting: [
            "Hello! How can I brighten your day? ✨",
            "Hey there! Ready to assist you with anything! 🚀",
            "Hi! What amazing thing can we accomplish together today? 💫"
        ],
        help: [
            "I can help with: \n• Answering questions\n• Setting reminders\n• Providing information\n• Making recommendations\n• Solving problems",
            "Here's what I can do for you:\n1. Answer queries\n2. Book appointments\n3. Send notifications\n4. Analyze data\n5. Provide insights"
        ],
        thanks: [
            "You're welcome! Happy to help! 😊",
            "My pleasure! Anything else you need? 🌟",
            "Anytime! That's what I'm here for! 🙌"
        ],
        default: [
            "That's fascinating! Tell me more about that.",
            "I understand. Let me think about the best solution for you.",
            "Great point! How can I assist you further with this?",
            "Interesting perspective! Let me dive deeper into that.",
            "I appreciate you sharing that. What would you like to know more about?"
        ]
    };

    // Get intelligent bot response
    // const getBotResponse = async (userInput) => {
    //     try {
    //         const res = await fetch(
    //             `${BASE_URL}/message/create`,
    //             {
    //                 method: 'POST',
    //                 headers: { 'Content-Type': 'application/json' },
    //                 body: JSON.stringify({ message: userInput , companyId : 1}),
    //             }
    //         );
    //         console.log("Bot response: 1", res.data);

    //         if (!res.ok) {
    //             throw new Error(`Request failed with status ${res.status}`);
    //         }

    //         const data = await res;
    //         // console.log("Bot response:", data);
    //         console.log("Bot response: 2", data);
    //         console.log("Bot response: 3", data.data.reply);
    //         console.log("Bot response: 4", data.status);



    //         return data?.data.reply || "Sorry, I couldn't get a valid response from the server.";
    //     } catch (error) {
    //         console.error('Bot response error:', error);
    //         return "server error 500: Oops! Something went wrong. Please try again later.";
    //     }
    //     // const input = userInput.toLowerCase();
    //     // if (input.includes("help") || input.includes("what can you do")) {
    //     //   return botResponses.help[Math.floor(Math.random() * botResponses.help.length)];
    //     // }
    //     // if (input.includes("thank") || input.includes("thanks")) {
    //     //   return botResponses.thanks[Math.floor(Math.random() * botResponses.thanks.length)];
    //     // }
    //     // if (input.includes("hi") || input.includes("hello") || input.includes("hey")) {
    //     //   return botResponses.greeting[Math.floor(Math.random() * botResponses.greeting.length)];
    //     // }
    //     // return botResponses.default[Math.floor(Math.random() * botResponses.default.length)];
    // };

    const getBotResponse = async (userInput) => {
        try {
            const res = await fetch(`${BASE_URL}/message/create`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({
                    message: userInput,
                    companyId: 1,
                }),
            });

            if (!res.ok) {
                throw new Error(`Request failed with status ${res.status}`);
            }

            const data = await res.json();

            console.log("Response:", data);
            console.log("Reply:", data.data.reply);

            return data?.data?.reply || "Sorry, I couldn't get a valid response from the server.";

        } catch (error) {
            console.error(error);
            return "Sorry, I encountered an error while processing your request.";
        }
    };

    // Auto-scroll
    useEffect(() => {
        messagesEndRef.current?.scrollIntoView({ behavior: "smooth" });
    }, [messages, isTyping]);

    // Focus management
    useEffect(() => {
        if (isOpen && !isMinimized && !isExpanded) {
            setTimeout(() => inputRef.current?.focus(), 300);
        }
    }, [isOpen, isMinimized, isExpanded]);

    // Online status simulation
    useEffect(() => {
        const interval = setInterval(() => {
            setIsOnline(navigator.onLine);
        }, 3000);
        return () => clearInterval(interval);
    }, []);

    // Unread count
    useEffect(() => {
        if (!isOpen) {
            const unread = messages.filter(m => m.type === "bot" && !m.isRead).length;
            setUnreadCount(unread);
        }
    }, [messages, isOpen]);

    // Suggestions based on input
    useEffect(() => {
        if (inputValue.length > 2) {
            const commonSuggestions = [
                "How does this work?",
                "Tell me about your features",
                "I need technical support",
                "Schedule a demo",
                "Pricing information",
                "Compare with alternatives"
            ];
            const filtered = commonSuggestions.filter(s =>
                s.toLowerCase().includes(inputValue.toLowerCase())
            );
            setSuggestions(filtered.slice(0, 3));
        } else {
            setSuggestions([]);
        }
    }, [inputValue]);

    // Send message
    const handleSendMessage = useCallback(async () => {
        if (!inputValue.trim() && uploadedFiles.length === 0) return;

        // Add user message
        const userMessage = {
            id: Date.now(),
            type: "user",
            text: inputValue,
            timestamp: new Date(),
            status: "sent",
            files: [...uploadedFiles],
            reactions: { likes: 0, dislikes: 0 },
            starred: false
        };

        setMessages(prev => [...prev, userMessage]);
        setInputValue("");
        setUploadedFiles([]);
        setIsTyping(true);
        setShowEmojiPicker(false);

        // Typing indicator with random duration
        const typingDuration = Math.random() * 1000 + 1000;

        setTimeout(() => {
            const botResponse = getBotResponse(inputValue);
            const botMessage = {
                id: Date.now() + 1,
                type: "bot",
                text: botResponse,
                timestamp: new Date(),
                status: "delivered",
                isRead: false,
                reactions: { likes: 0, dislikes: 0 },
                starred: false
            };
            setMessages(prev => [...prev, botMessage]);
            setIsTyping(false);

            // Play notification sound if not muted and chat is minimized
            if (!isMuted && isMinimized) {
                const audio = new Audio("data:audio/wav;base64,U3RlYWx0aCBzb3VuZA==");
                audio.play().catch(() => { });
            }
        }, typingDuration);
    }, [inputValue, uploadedFiles, isMuted, isMinimized]);

    // File upload handling
    const handleFileUpload = (e) => {
        const files = Array.from(e.target.files);
        const fileData = files.map(file => ({
            id: Date.now() + Math.random(),
            name: file.name,
            size: file.size,
            type: file.type,
            url: URL.createObjectURL(file)
        }));
        setUploadedFiles(prev => [...prev, ...fileData]);
    };

    // Voice recording simulation
    const startVoiceRecording = () => {
        setIsRecording(true);
        setRecordingTime(0);
        recordingIntervalRef.current = setInterval(() => {
            setRecordingTime(t => t + 1);
        }, 1000);

        // Simulate voice recognition
        setTimeout(() => {
            if (recordingIntervalRef.current) {
                clearInterval(recordingIntervalRef.current);
                setIsRecording(false);
                setInputValue("I'd like to know more about your services please");
            }
        }, 3000);
    };

    const stopVoiceRecording = () => {
        if (recordingIntervalRef.current) {
            clearInterval(recordingIntervalRef.current);
            setIsRecording(false);
        }
    };

    // Message actions
    const copyMessage = (text) => {
        navigator.clipboard.writeText(text);
        showToast("Copied to clipboard!");
    };

    const reactToMessage = (messageId, reaction) => {
        setMessages(prev => prev.map(msg =>
            msg.id === messageId
                ? { ...msg, reactions: { ...msg.reactions, [reaction]: msg.reactions[reaction] + 1 } }
                : msg
        ));
    };

    const starMessage = (messageId) => {
        setMessages(prev => prev.map(msg =>
            msg.id === messageId ? { ...msg, starred: !msg.starred } : msg
        ));
    };

    const deleteMessage = (messageId) => {
        setMessages(prev => prev.filter(msg => msg.id !== messageId));
    };

    const editMessage = (messageId, newText) => {
        setMessages(prev => prev.map(msg =>
            msg.id === messageId ? { ...msg, text: newText, isEdited: true } : msg
        ));
        setEditingMessage(null);
    };

    // Export chat
    const exportChat = () => {
        const chatData = JSON.stringify(messages, null, 2);
        const blob = new Blob([chatData], { type: "application/json" });
        const url = URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;
        a.download = `chat-export-${Date.now()}.json`;
        a.click();
        URL.revokeObjectURL(url);
        showToast("Chat exported successfully!");
    };

    // Clear chat with confirmation
    const clearChat = () => {
        if (window.confirm("Are you sure you want to clear all messages?")) {
            const welcomeMessage = {
                id: Date.now(),
                type: "bot",
                text: "Chat cleared! How can I help you fresh? ✨",
                timestamp: new Date(),
                status: "read",
                reactions: { likes: 0, dislikes: 0 },
                starred: false
            };
            setMessages([welcomeMessage]);
            showToast("Chat cleared successfully!");
        }
    };

    // Toast notification
    const showToast = (message) => {
        const toast = document.createElement("div");
        toast.className = "fixed bottom-24 right-24 bg-gray-800 text-white px-4 py-2 rounded-lg shadow-lg z-50 animate-fade-in-up";
        toast.textContent = message;
        document.body.appendChild(toast);
        setTimeout(() => toast.remove(), 3000);
    };

    // Format time
    const formatTime = (date) => {
        return date.toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" });
    };

    // Format file size
    const formatFileSize = (bytes) => {
        if (bytes < 1024) return bytes + " B";
        if (bytes < 1048576) return (bytes / 1024).toFixed(1) + " KB";
        return (bytes / 1048576).toFixed(1) + " MB";
    };

    // Emoji list
    const emojis = ["😀", "😂", "😍", "🤔", "👍", "❤️", "🎉", "🔥", "✨", "🌟", "💡", "🚀", "🎨", "💎", "⭐", "🏆"];

    // Font size classes
    const fontSizeClasses = {
        small: "text-xs",
        medium: "text-sm",
        large: "text-base"
    };

    return (
        <>
            {/* Custom CSS Animations */}
            <style>{`
        @keyframes gradient {
          0%, 100% { background-position: 0% 50%; }
          50% { background-position: 100% 50%; }
        }
        @keyframes fade-in-up {
          from {
            opacity: 0;
            transform: translateY(20px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }
        @keyframes pulse-ring {
          0% { transform: scale(0.8); opacity: 1; }
          100% { transform: scale(1.5); opacity: 0; }
        }
        @keyframes typing {
          0%, 100% { transform: translateY(0); }
          50% { transform: translateY(-5px); }
        }
        @keyframes shake {
          0%, 100% { transform: translateX(0); }
          25% { transform: translateX(-5px); }
          75% { transform: translateX(5px); }
        }
        @keyframes spin {
          from { transform: rotate(0deg); }
          to { transform: rotate(360deg); }
        }
        .animate-gradient {
          background-size: 200% 200%;
          animation: gradient 3s ease infinite;
        }
        .animate-fade-in-up {
          animation: fade-in-up 0.3s ease-out;
        }
        .animate-pulse-ring::before {
          content: '';
          position: absolute;
          width: 100%;
          height: 100%;
          background: rgba(59, 130, 246, 0.4);
          border-radius: 50%;
          animation: pulse-ring 1.5s infinite;
        }
        .dark-mode {
          background: linear-gradient(135deg, #1a1a2e 0%, #16213e 100%);
          color: #eee;
        }
        .dark-mode .bg-white {
          background: #1e293b !important;
          color: #e2e8f0 !important;
        }
        .dark-mode .border-gray-100,
        .dark-mode .border-gray-200 {
          border-color: #334155 !important;
        }
        .dark-mode .bg-gray-50,
        .dark-mode .bg-gray-100 {
          background: #0f172a !important;
        }
        .dark-mode .text-gray-700 {
          color: #cbd5e1 !important;
        }
        .scrollbar-thin::-webkit-scrollbar {
          width: 4px;
        }
        .scrollbar-thin::-webkit-scrollbar-track {
          background: #f1f1f1;
          border-radius: 10px;
        }
        .scrollbar-thin::-webkit-scrollbar-thumb {
          background: #888;
          border-radius: 10px;
        }
        .glass-effect {
          backdrop-filter: blur(10px);
          background: rgba(255, 255, 255, 0.95);
        }
        .dark-mode .glass-effect {
          background: rgba(15, 23, 42, 0.95);
        }
      `}</style>

            {/* Floating Toggle Button */}
            <motion.button
                onClick={() => setIsOpen((prev) => !prev)}
                className={`fixed right-6 bottom-6 z-50 w-14 h-14 rounded-full shadow-2xl flex items-center justify-center group transition-all duration-300 ${darkMode ? "bg-gradient-to-r from-purple-600 to-pink-500" : "bg-gradient-to-r from-blue-600 to-blue-500"
                    } text-white`}
                whileHover={{ scale: 1.1, rotate: 5 }}
                whileTap={{ scale: 0.95 }}
                initial={{ scale: 0, rotate: -180 }}
                animate={{ scale: 1, rotate: 0 }}
                transition={{ type: "spring", stiffness: 260, damping: 20 }}
            >
                {unreadCount > 0 && (
                    <motion.span
                        initial={{ scale: 0 }}
                        animate={{ scale: 1 }}
                        className="absolute -top-1 -right-1 w-5 h-5 bg-red-500 text-white text-[10px] rounded-full flex items-center justify-center font-bold"
                    >
                        {unreadCount > 9 ? "9+" : unreadCount}
                    </motion.span>
                )}
                {/* <MessageCircle className="w-6 h-6 group-hover:rotate-12 transition-transform" /> */}
                <Bot className="w-6 h-6" />
                <span className="absolute inset-0 rounded-full animate-pulse-ring" />
            </motion.button>

            {/* Main Chat Window */}
            <AnimatePresence>
                {isOpen && (
                    <motion.div
                        initial={{ opacity: 0, y: 50, scale: 0.9, rotateX: -15 }}
                        animate={{
                            opacity: 1,
                            y: 0,
                            scale: 1,
                            rotateX: 0,
                            ...(isMinimized && { height: "64px", width: "340px" }),
                            ...(isExpanded && { width: "90vw", height: "80vh", maxWidth: "1200px" })
                        }}

                        exit={{ opacity: 0, y: 50, scale: 0.9 }}
                        transition={{ type: "spring", damping: 25, stiffness: 300 }}
                        className={`fixed right-6 bottom-24 z-50 rounded-2xl shadow-2xl overflow-hidden flex flex-col ${darkMode ? "glass-effect" : "bg-white"
                            } border ${darkMode ? "border-gray-700" : "border-gray-100"} ${isMinimized ? "h-14 w-[340px]" : isExpanded ? "w-[90vw] h-[80vh] max-w-[1200px]" : "h-[600px] w-[420px]"
                            }`}
                        style={{ transformStyle: "preserve-3d" }}
                    >
                        {/* Header with Gradient */}
                        <div className={`bg-gradient-to-r from-blue-600 via-emerald-500 to-blue-600 bg-size-200 animate-gradient px-4 py-3 flex items-center justify-between text-white shadow-lg`}>
                            <div className="flex items-center gap-2">
                                <div className="relative">
                                    <div className="w-10 h-10 rounded-full bg-white/20 flex items-center justify-center backdrop-blur-sm">
                                        <Bot className="w-5 h-5" />
                                    </div>
                                    {isOnline && (
                                        <span className="absolute bottom-0 right-0 w-3 h-3 bg-green-400 rounded-full border-2 border-white animate-pulse" />
                                    )}
                                </div>
                                <div>
                                    <h3 className="font-bold text-sm">AI Assistant</h3>
                                    <div className="flex items-center gap-1 text-xs text-white/90">
                                        {isOnline ? (
                                            <>
                                                <Wifi className="w-3 h-3" />
                                                <span>Online</span>
                                            </>
                                        ) : (
                                            <>
                                                <WifiOff className="w-3 h-3" />
                                                <span>Offline</span>
                                            </>
                                        )}
                                        <span className="w-1 h-1 rounded-full bg-white/50" />
                                        <span>Response time: ~1.5s</span>
                                    </div>
                                </div>
                            </div>

                            <div className="flex items-center gap-1">
                                <button
                                    onClick={() => setDarkMode(!darkMode)}
                                    className="p-1.5 hover:bg-white/20 rounded-lg transition-colors"
                                    title="Toggle dark mode"
                                >
                                    {darkMode ? "☀️" : "🌙"}
                                </button>
                                <button
                                    onClick={() => setShowSettings(!showSettings)}
                                    className="p-1.5 hover:bg-white/20 rounded-lg transition-colors"
                                >
                                    <Settings className="w-4 h-4" />
                                </button>
                                {/* <button
                  onClick={() => setIsExpanded(!isExpanded)}
                  className="p-1.5 hover:bg-white/20 rounded-lg transition-colors"
                >
                  {isExpanded ? <Minimize2 className="w-4 h-4" /> : <Maximize2 className="w-4 h-4" />}
                </button> */}
                                {/* <button
                  onClick={() => setIsMinimized(!isMinimized)}
                  className="p-1.5 hover:bg-white/20 rounded-lg transition-colors"
                >
                  {isMinimized ? <ChevronUp className="w-4 h-4" /> : <ChevronDown className="w-4 h-4" />}
                </button> */}
                                <button
                                    onClick={() => setIsOpen(false)}
                                    className="p-1.5 hover:bg-white/20 rounded-lg transition-colors"
                                >
                                    <X className="w-4 h-4" />
                                </button>
                            </div>
                        </div>

                        {/* Settings Panel */}
                        <AnimatePresence>
                            {showSettings && !isMinimized && (
                                <motion.div
                                    initial={{ height: 0, opacity: 0 }}
                                    animate={{ height: "auto", opacity: 1 }}
                                    exit={{ height: 0, opacity: 0 }}
                                    className={`border-b ${darkMode ? "border-gray-700 bg-gray-800" : "border-gray-100 bg-gray-50"} p-4 overflow-hidden`}
                                >
                                    <div className="space-y-3">
                                        <div className="flex items-center justify-between">
                                            <span className="text-sm font-medium">Font Size</span>
                                            <div className="flex gap-2">
                                                {["small", "medium", "large"].map(size => (
                                                    <button
                                                        key={size}
                                                        onClick={() => setFontSize(size)}
                                                        className={`px-3 py-1 text-xs rounded-lg transition ${fontSize === size
                                                            ? "bg-blue-500 text-white"
                                                            : darkMode ? "bg-gray-700 text-gray-300" : "bg-white text-gray-700"
                                                            }`}
                                                    >
                                                        {size}
                                                    </button>
                                                ))}
                                            </div>
                                        </div>
                                        {/* <div className="flex items-center justify-between">
                      <span className="text-sm font-medium">Language</span>
                      <select
                        value={language}
                        onChange={(e) => setLanguage(e.target.value)}
                        className={`text-sm rounded-lg px-2 py-1 ${
                          darkMode ? "bg-gray-700 text-white" : "bg-white border border-gray-200"
                        }`}
                      >
                        <option value="en">English</option>
                        <option value="es">Español</option>
                        <option value="fr">Français</option>
                        <option value="de">Deutsch</option>
                      </select>
                    </div> */}
                                        <div className="flex gap-2">
                                            <button
                                                onClick={exportChat}
                                                className="flex-1 px-3 py-2 text-sm bg-green-500 text-white rounded-lg hover:bg-green-600 transition flex items-center justify-center gap-2"
                                            >
                                                <Download className="w-4 h-4" />
                                                Export Chat
                                            </button>
                                            <button
                                                onClick={clearChat}
                                                className="flex-1 px-3 py-2 text-sm bg-red-500 text-white rounded-lg hover:bg-red-600 transition flex items-center justify-center gap-2"
                                            >
                                                <Trash2 className="w-4 h-4" />
                                                Clear Chat
                                            </button>
                                        </div>
                                    </div>
                                </motion.div>
                            )}
                        </AnimatePresence>

                        {/* Messages Area */}
                        {!isMinimized && (
                            <>
                                <div
                                    ref={chatContainerRef}
                                    className={`flex-1 overflow-y-auto p-4 space-y-3 scrollbar-thin ${darkMode ? "bg-gradient-to-b from-gray-900 to-gray-800" : "bg-gradient-to-b from-gray-50 to-white"
                                        }`}
                                >
                                    {/* Filter Bar */}
                                    <div className="flex gap-2 mb-3 sticky top-0 z-10">
                                        {["all"].map(filter => (
                                            <button
                                                key={filter}
                                                onClick={() => setFilterType(filter)}
                                                className={`px-2 py-1 text-xs rounded-full capitalize transition ${filterType === filter
                                                    ? "bg-blue-500 text-white"
                                                    : darkMode ? "bg-gray-700 text-gray-300" : "bg-white text-gray-600 border border-gray-200"
                                                    }`}
                                            >
                                                {filter}
                                            </button>
                                        ))}
                                    </div>

                                    {/* Messages */}
                                    {messages
                                        .filter(msg => {
                                            if (filterType === "all") return true;
                                            if (filterType === "starred") return msg.starred;
                                            return msg.type === filterType;
                                        })
                                        .map((message, index) => (
                                            <motion.div
                                                key={message.id}
                                                initial={{ opacity: 0, y: 20, x: message.type === "user" ? 50 : -50 }}
                                                animate={{ opacity: 1, y: 0, x: 0 }}
                                                transition={{ delay: index * 0.05 }}
                                                className={`flex ${message.type === "user" ? "justify-end" : "justify-start"}`}
                                            >
                                                <div className={`max-w-[85%] group relative ${message.type === "user" ? "order-2" : "order-1"
                                                    }`}>
                                                    {/* Message Bubble */}
                                                    <div
                                                        className={`rounded-2xl px-4 py-2 shadow-md transition-all hover:shadow-lg ${message.type === "user"
                                                            ? "bg-gradient-to-r from-blue-600 to-blue-500 text-white rounded-br-md"
                                                            : darkMode
                                                                ? "bg-gray-800 text-gray-100 border border-gray-700 rounded-bl-md"
                                                                : "bg-white text-gray-700 border border-gray-200 rounded-bl-md"
                                                            }`}
                                                    >
                                                        <div className="flex items-start gap-2">
                                                            {message.type === "bot" && (
                                                                <div className="w-6 h-6 rounded-full bg-blue-100 flex items-center justify-center flex-shrink-0">
                                                                    <Bot className="w-3.5 h-3.5 text-blue-600" />
                                                                </div>
                                                            )}
                                                            <div className="flex-1">
                                                                {editingMessage === message.id ? (
                                                                    <input
                                                                        type="text"
                                                                        defaultValue={message.text}
                                                                        onKeyPress={(e) => {
                                                                            if (e.key === "Enter") {
                                                                                editMessage(message.id, e.target.value);
                                                                            }
                                                                        }}
                                                                        className={`w-full px-2 py-1 rounded ${darkMode ? "bg-gray-700 text-white" : "bg-gray-100"
                                                                            }`}
                                                                        autoFocus
                                                                    />
                                                                ) : (
                                                                    <p className={`${fontSizeClasses[fontSize]} leading-relaxed`}>
                                                                        {message.text}
                                                                    </p>
                                                                )}

                                                                {/* File Attachments */}
                                                                {message.files && message.files.length > 0 && (
                                                                    <div className="mt-2 space-y-1">
                                                                        {message.files.map(file => (
                                                                            <div key={file.id} className={`flex items-center gap-2 text-xs ${message.type === "user" ? "text-blue-100" : "text-gray-500"
                                                                                }`}>
                                                                                {file.type.startsWith("image/") ? (
                                                                                    <Image className="w-3 h-3" />
                                                                                ) : (
                                                                                    <FileText className="w-3 h-3" />
                                                                                )}
                                                                                <span>{file.name}</span>
                                                                                <span>({formatFileSize(file.size)})</span>
                                                                            </div>
                                                                        ))}
                                                                    </div>
                                                                )}

                                                                <div className="flex items-center gap-2 mt-1">
                                                                    <span className="text-[10px] opacity-60">
                                                                        {formatTime(message.timestamp)}
                                                                    </span>
                                                                    {message.isEdited && (
                                                                        <span className="text-[10px] opacity-60">(edited)</span>
                                                                    )}
                                                                    {message.status && (
                                                                        <span className="text-[10px] opacity-60">
                                                                            {message.status === "sent" && "✓"}
                                                                            {message.status === "delivered" && "✓✓"}
                                                                            {message.status === "read" && "✓✓"}
                                                                        </span>
                                                                    )}
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>

                                                    {/* Message Actions */}
                                                    <div className={`absolute top-0 ${message.type === "user" ? "-left-20" : "-right-20"
                                                        } opacity-0 group-hover:opacity-100 transition-opacity flex gap-1`}>
                                                        <button
                                                            onClick={() => copyMessage(message.text)}
                                                            className="p-1 rounded bg-gray-200 hover:bg-gray-300 transition"
                                                            title="Copy"
                                                        >
                                                            <Copy className="w-3 h-3" />
                                                        </button>
                                                        <button
                                                            onClick={() => reactToMessage(message.id, "likes")}
                                                            className="p-1 rounded bg-gray-200 hover:bg-gray-300 transition"
                                                            title="Like"
                                                        >
                                                            <ThumbsUp className="w-3 h-3" />
                                                        </button>
                                                        <button
                                                            onClick={() => starMessage(message.id)}
                                                            className={`p-1 rounded transition ${message.starred ? "bg-yellow-400 text-white" : "bg-gray-200 hover:bg-gray-300"
                                                                }`}
                                                            title="Star"
                                                        >
                                                            <Star className="w-3 h-3" />
                                                        </button>
                                                        {message.type === "user" && (
                                                            <button
                                                                onClick={() => setEditingMessage(message.id)}
                                                                className="p-1 rounded bg-gray-200 hover:bg-gray-300 transition"
                                                                title="Edit"
                                                            >
                                                                <Edit2 className="w-3 h-3" />
                                                            </button>
                                                        )}
                                                        <button
                                                            onClick={() => deleteMessage(message.id)}
                                                            className="p-1 rounded bg-red-200 hover:bg-red-300 transition"
                                                            title="Delete"
                                                        >
                                                            <Trash2 className="w-3 h-3" />
                                                        </button>
                                                    </div>
                                                </div>
                                            </motion.div>
                                        ))}

                                    {/* Typing Indicator */}
                                    {isTyping && (
                                        <motion.div
                                            initial={{ opacity: 0 }}
                                            animate={{ opacity: 1 }}
                                            className="flex justify-start"
                                        >
                                            <div className={`rounded-2xl rounded-bl-md px-4 py-3 shadow-sm ${darkMode ? "bg-gray-800 border border-gray-700" : "bg-white border border-gray-200"
                                                }`}>
                                                <div className="flex gap-1.5">
                                                    <span className="w-2 h-2 bg-blue-500 rounded-full animate-bounce" style={{ animationDelay: "0ms" }} />
                                                    <span className="w-2 h-2 bg-blue-500 rounded-full animate-bounce" style={{ animationDelay: "150ms" }} />
                                                    <span className="w-2 h-2 bg-blue-500 rounded-full animate-bounce" style={{ animationDelay: "300ms" }} />
                                                </div>
                                            </div>
                                        </motion.div>
                                    )}

                                    <div ref={messagesEndRef} />
                                </div>

                                {/* Suggestions */}
                                {suggestions.length > 0 && (
                                    <div className="px-4 py-2 border-t border-gray-100 bg-gray-50 overflow-x-auto">
                                        <div className="flex gap-2">
                                            {suggestions.map(suggestion => (
                                                <button
                                                    key={suggestion}
                                                    onClick={() => setInputValue(suggestion)}
                                                    className="px-3 py-1 text-xs bg-white rounded-full border border-gray-200 hover:border-blue-300 hover:bg-blue-50 transition whitespace-nowrap"
                                                >
                                                    {suggestion}
                                                </button>
                                            ))}
                                        </div>
                                    </div>
                                )}

                                {/* Quick Actions */}
                                <div className={`px-4 py-2 border-t ${darkMode ? "border-gray-700" : "border-gray-100"} ${darkMode ? "bg-gray-800" : "bg-gray-50"
                                    }`}>
                                    <div className="flex items-center gap-2 overflow-x-auto pb-1 scrollbar-thin">
                                        {[
                                            { icon: Sparkles, label: "Help", action: () => setInputValue("Can you help me?") },
                                            { icon: Zap, label: "Features", action: () => setInputValue("What features do you have?") },
                                            { icon: Clock, label: "Hours", action: () => setInputValue("What are your business hours?") },
                                            { icon: Shield, label: "Security", action: () => setInputValue("Tell me about security") },
                                            { icon: FileText, label: "Docs", action: () => setInputValue("Show me documentation") },
                                            { icon: Link2, label: "Links", action: () => setInputValue("Send me important links") },
                                        ].map(({ icon: Icon, label, action }) => (
                                            <button
                                                key={label}
                                                onClick={action}
                                                className={`px-3 py-1.5 text-xs rounded-full border transition whitespace-nowrap flex items-center gap-1 ${darkMode
                                                    ? "border-gray-600 hover:border-blue-400 hover:bg-gray-700 text-gray-300"
                                                    : "border-gray-200 hover:border-blue-300 hover:bg-blue-50 text-gray-700"
                                                    }`}
                                            >
                                                <Icon className="w-3 h-3" />
                                                {label}
                                            </button>
                                        ))}
                                    </div>
                                </div>

                                {/* Input Area */}
                                <div className={`p-3 border-t ${darkMode ? "border-gray-700 bg-gray-800" : "border-gray-100 bg-white"}`}>
                                    {/* Uploaded Files Preview */}
                                    {/* {uploadedFiles.length > 0 && (
                    <div className="mb-2 flex gap-2 flex-wrap">
                      {uploadedFiles.map(file => (
                        <div key={file.id} className={`flex items-center gap-1 text-xs px-2 py-1 rounded ${
                          darkMode ? "bg-gray-700 text-gray-300" : "bg-gray-100"
                        }`}>
                          <FileText className="w-3 h-3" />
                          <span>{file.name}</span>
                          <button
                            onClick={() => setUploadedFiles(prev => prev.filter(f => f.id !== file.id))}
                            className="ml-1 hover:text-red-500"
                          >
                            <X className="w-3 h-3" />
                          </button>
                        </div>
                      ))}
                    </div>
                  )} */}

                                    <div className="flex items-center gap-2">


                                        <div className="flex-1 relative">
                                            <textarea
                                                ref={inputRef}
                                                value={inputValue}
                                                onChange={(e) => setInputValue(e.target.value)}
                                                onKeyPress={(e) => {
                                                    if (e.key === "Enter" && !e.shiftKey) {
                                                        e.preventDefault();
                                                        handleSendMessage();
                                                    }
                                                }}
                                                placeholder="Type your message"
                                                rows="1"
                                                className={`w-full px-3 py-2 text-sm rounded-xl border transition resize-none ${darkMode
                                                    ? "bg-gray-700 border-gray-600 text-white focus:border-blue-500"
                                                    : "bg-gray-100 border-transparent focus:border-blue-300 focus:ring-2 focus:ring-blue-200"
                                                    } focus:outline-none`}
                                                style={{ minHeight: "40px", maxHeight: "100px", scrollbarWidth: "thin" }}
                                            />

                                            {/* Character Count */}
                                            <div className="absolute right-2 bottom-1 text-[10px] text-gray-400">
                                                {inputValue.length}/500
                                            </div>
                                        </div>

                                        <div className="flex gap-1">
                                            <button
                                                onClick={handleSendMessage}
                                                disabled={!inputValue.trim() && uploadedFiles.length === 0}
                                                className={`p-2 rounded-full transition-all ${inputValue.trim() || uploadedFiles.length > 0
                                                    ? `bg-gradient-to-r from-blue-600 to-blue-500 text-white shadow-md hover:shadow-lg ${darkMode ? "from-purple-600 to-pink-500" : ""
                                                    }`
                                                    : darkMode ? "text-gray-600 bg-gray-700" : "text-gray-400 bg-gray-100"
                                                    }`}
                                            >
                                                <Send className="w-5 h-5" />
                                            </button>
                                            {/* <button
                        onClick={() => setIsMuted(!isMuted)}
                        className={`p-2 rounded-full transition-colors ${
                          darkMode ? "text-gray-400 hover:text-gray-300 hover:bg-gray-700" : "text-gray-400 hover:text-gray-600 hover:bg-gray-100"
                        }`}
                      >
                        {isMuted ? <VolumeX className="w-5 h-5" /> : <Volume2 className="w-5 h-5" />}
                      </button> */}
                                            <button
                                                onClick={() => window.open("https://wa.me/1234567890", "_blank")}
                                                className={`p-2 rounded-full transition-colors ${darkMode ? "text-gray-400 hover:text-gray-300 hover:bg-gray-700" : "text-gray-400 hover:text-gray-600 hover:bg-gray-100"
                                                    }`}
                                            >
                                                <Share2 className="w-5 h-5" />
                                            </button>
                                        </div>
                                    </div>

                                    {/* Recording Indicator */}
                                    {/* {isRecording && (
                    <div className="mt-2 flex items-center justify-center gap-2 text-xs text-red-500">
                      <div className="w-2 h-2 bg-red-500 rounded-full animate-pulse" />
                      Recording... {recordingTime}s
                    </div>
                  )} */}
                                </div>
                            </>
                        )}
                    </motion.div>
                )}
            </AnimatePresence>
        </>
    );
};

export default ChatbotWidget;